/* tslint:disable */
/* eslint-disable */
/**
 * Citra
 * Generali Epargne Salariale
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface Abondement {
    'typePalier'?: string;
    'palierAbondements'?: Array<PalierAbondement>;
    'palierAncienneteAbondements'?: PalierAncienneteAbondement;
    'plafondPass': boolean;
    'sourceVersements': Array<string>;
}
export interface AbondementUnilateral {
    'miseEnPlace': boolean;
    'periodiqueMontant'?: number;
    'amorcageMontant'?: number;
}
export interface Actionnaires {
    'nom'?: string;
    'prenom'?: string;
    'raisonSociale'?: string;
    'qualite'?: ActionnairesQualiteEnum;
    'adressePermanente'?: Adresse;
    'adressePostale'?: Adresse;
    'paysFiscal'?: Pays;
    'activiteBeneficiaire'?: string;
    'fonctionDirigeant'?: string;
    'parts'?: number;
    'beneficiaireIsPersonneMorale'?: boolean;
    'typeControle'?: ActionnairesTypeControleEnum;
    'civilite'?: Civilite;
    'dateNaissance'?: string;
    'nomNaissance'?: string;
    'adresseNaissance'?: Adresse;
    'paysNationalite'?: string;
}

export const ActionnairesQualiteEnum = {
    D: 'D',
    B: 'B',
    P: 'P',
    A: 'A',
} as const;

export type ActionnairesQualiteEnum = typeof ActionnairesQualiteEnum[keyof typeof ActionnairesQualiteEnum];
export const ActionnairesTypeControleEnum = {
    Capital: 'capital',
    Vote: 'vote',
    Pouvoir: 'pouvoir',
} as const;

export type ActionnairesTypeControleEnum = typeof ActionnairesTypeControleEnum[keyof typeof ActionnairesTypeControleEnum];

export interface Activity {
    'label'?: string;
    'id'?: number;
}
export interface Adresse {
    'rue'?: string;
    'ville': string;
    'codePostal': string;
    'pays'?: Pays;
}
export interface AgreementDetails {
    'agreementType'?: string;
    'employeesOption'?: string;
    'duration'?: Duration;
}
export interface AjoutEntreprise {
    'jwt': string;
    'dossierAvecEntreprise': DossierAvecEntreprise;
}
export interface ApiError {
    'code'?: string;
    'message'?: string;
    'timestamp'?: string;
}
export interface Apporteur {
    'uuid'?: string;
    'creationDate'?: string;
    'updateDate'?: string;
    'roles'?: Array<Role>;
    'permissions'?: Array<Permission>;
    'authProviderInformations'?: ApporteurLightAuthProviderInformations;
    'businessInformations'?: ApporteurBusinessInformations;
    'nbDossiers'?: number;
    'notTransmitted'?: boolean;
}
export interface ApporteurAffaire {
    'adresseEmail'?: string;
    'reseau'?: string;
    'uniteOrganisationnelle'?: string;
    'codeApporteur'?: string;
    'nomApporteur'?: string;
    'prenomApporteur'?: string;
    'codePortefeuille'?: string;
    'codeReseau'?: string;
    'telephoneApporteur'?: string;
}
export interface ApporteurBusinessInformations {
    'inscriptionHarvest'?: boolean;
    'nomCabinet'?: string;
    'codeApporteur30'?: string;
    'codeApporteur60'?: string;
    'codeIntermediaire'?: string;
    'groupe'?: Groupe;
    'inspecteur'?: Inspecteur;
}
export interface ApporteurLight {
    'rolesId'?: Array<number>;
    'authProviderInformations'?: ApporteurLightAuthProviderInformations;
    'businessInformations'?: ApporteurLightBusinessInformations;
}
export interface ApporteurLightAuthProviderInformations {
    'authId'?: string;
    'email'?: string;
    'familyName'?: string;
    'givenName'?: string;
    'telephone'?: string;
}
export interface ApporteurLightBusinessInformations {
    'inscriptionHarvest'?: boolean;
    'nomCabinet'?: string;
    'codeApporteur30'?: string;
    'codeApporteur60'?: string;
    'codeIntermediaire'?: string;
    'groupeId'?: number;
    'inspecteurId'?: number;
}
export interface ApporteurTelephoneUpdate {
    'authId'?: string;
    'telephone'?: string;
}
export interface ApporteurWithFoldersId {
    'userToUpdate'?: Apporteur;
    'foldersUID'?: Array<string>;
}
export interface Apporteurs extends Array<Apporteur> {
}
export interface Article {
    'id'?: string;
    'title'?: string;
    'text'?: string;
    'link'?: string;
}
export interface Articles extends Array<Article> {
}
export interface Beneficiaries {
    'companyHead'?: boolean;
    'spouse'?: boolean;
    'seniority'?: number;
}
export interface BibliothequeDocument {
    'id'?: string;
    'sectionId'?: number;
    'fileName'?: string;
    'displayName'?: string;
    'position'?: number;
}
export interface BibliothequeSection {
    'id'?: number;
    'name'?: string;
    'tags'?: string;
    'logo'?: string;
    'position'?: string;
    'type'?: string;
    'documents'?: Array<BibliothequeDocument>;
}
export interface Bonus {
    'beneficiaries'?: Beneficiaries;
    'ceiling'?: Ceiling;
    'distribution'?: Distribution;
}
export interface CategoriesSalaries {
    'collegeCategory': string;
    'collegeOption': string;
    'tauxCategory': string;
    'tauxTranche1'?: string;
    'tauxTranche2'?: string;
    'tauxPMSS'?: string;
}
export interface Ceiling {
    'budgetPercent'?: boolean;
    'overallPayroll'?: number;
    'collectiveBudgetType'?: string;
    'collectiveBudgetEuro'?: number;
    'collectiveBudgetPercentage'?: number;
}

export const Civilite = {
    Monsieur: 'Monsieur',
    Madame: 'Madame',
    Mademoiselle: 'Mademoiselle',
} as const;

export type Civilite = typeof Civilite[keyof typeof Civilite];


export interface Commentaire {
    'dossierUid'?: string;
    'commentaire'?: string;
}
export interface Commission {
    'id'?: string;
    'sourceCommissionId'?: string;
    'mois'?: string;
    'codeGroupe'?: string;
    'labelGroupe'?: string;
    'labelReseau'?: string;
    'nomPrenomDistributeur'?: string;
    'codeApporteur'?: string;
    'inspecteur'?: string;
    'codeEntreprise'?: string;
    'labelEntreprise'?: string;
    'codeIsinFonds'?: string;
    'codeFonds'?: string;
    'labelFonds'?: string;
    'labelSocieteGestion'?: string;
    'dateVl'?: string;
    'vl'?: number;
    'nombreParts'?: number;
    'encoursMensuel'?: number;
    'nombrePorteursDynamique'?: number;
    'tauxMensuelCommissionDistributeur'?: number;
    'commissionMensuelleEncoursDistributeurs'?: number;
    'droitsEntreesTotalesFonds'?: number;
    'droitsEntreesPayesDistributeurs'?: number;
    'fraisDossiers'?: number;
    'fraisDossiersReservesDistributeurs'?: number;
    'totalVerseDistributeurs'?: number;
    'dateCreation'?: string;
}
export interface CompanyInfo {
    'siret'?: string;
    'name'?: string;
    'legalStatus'?: string;
    'headquarters'?: string;
    'capital'?: number;
    'representative'?: string;
    'job'?: string;
    'collectiveBargainingAgreement'?: string;
}
export interface CompanySector {
    'sectorName'?: string;
    'sectorId'?: number;
    'criteria'?: CompanySectorCriteria;
}
export interface CompanySectorCriteria {
    'financialCriteria'?: Array<string>;
    'qualitativeCriteria'?: Array<string>;
    'sustainabilityCriteria'?: Array<string>;
}
export interface CompteDePrelevement {
    'iban': string;
    'bic'?: string;
}
export interface ContactData {
    'clientName'?: string;
    'companyName'?: string;
    'emailAddress'?: string;
    'phoneNumber'?: string;
    'comment'?: string;
}
export interface Criteria extends Array<Criterion> {
}
export interface Criterion {
    'label'?: string;
    'type'?: string;
    'companySectorsId'?: number;
    'status'?: string;
    'weighting'?: number;
    'isDetermining'?: boolean;
}
export interface CustomTunnelData {
    'nomReseau'?: string;
    'logo'?: CustomTunnelDataLogo;
    'palette'?: CustomTunnelDataPalette;
    'customMailBienvenue'?: CustomTunnelDataCustomMailBienvenue;
}
export interface CustomTunnelDataCustomMailBienvenue {
    'header'?: CustomTunnelDataLogo;
    'pj'?: Array<string>;
    'lienAvis'?: string;
}
export interface CustomTunnelDataLogo {
    'name'?: string;
    'width'?: string;
    'height'?: string;
}
export interface CustomTunnelDataPalette {
    'couleurTitreFond'?: string;
    'couleurTitreTexte'?: string;
}
export interface Dirigeant {
    'civilite'?: Civilite;
    'nom': string;
    'prenom': string;
    'nomNaissance'?: string;
    'indicatifCode'?: string;
    'telephone': string;
    'fonction'?: string;
    'adresseEmail'?: string;
    'paysNaissance'?: Pays;
    'paysResidence'?: Pays;
    'nir'?: string;
    'dateNaissance'?: string;
    'adresse'?: Adresse;
    'adresseNaissance'?: Adresse;
    'nationalites'?: string;
}


export interface DirigeantRecap {
    'nom': string;
    'prenom': string;
}
export interface Dispositif {
    'ouverture': boolean;
    'abondement'?: Abondement;
    'abondementUnilateral'?: AbondementUnilateral;
}
export interface Dispositifs {
    'dispositifPei': Dispositif;
    'dispositifPercoi': Dispositif;
    'anciennete'?: number;
    'periodicite'?: Periodicite;
    'modalites'?: Modalites;
}
export interface Distribution {
    'beneficiariesChecked'?: boolean;
    'beneficiariesWeighting'?: number;
    'presenceChecked'?: boolean;
    'presenceWeighting'?: number;
    'salaryChecked'?: boolean;
    'salaryWeighting'?: number;
}
export interface DonneesKYC {
    'paysFiscalEntreprise'?: Pays;
    'adressePostaleEntreprise'?: Adresse;
    'regulateur'?: Regulateur;
    'entrepriseCotee'?: string;
    'paysCotation'?: Pays;
    'codeBIC'?: string;
    'soumisTVA'?: boolean;
    'codeTVAIntracommunautaire'?: string;
    'identifiantFacturationElectronique'?: string;
    'bonsPorteur'?: number;
    'paysPersonneMorale'?: Pays;
    'paysActivite'?: PaysActivite;
    'principauxPays'?: string;
    'principauxMarches'?: string;
    'lieuExercice'?: LieuExercice;
    'actionnaires'?: Array<Actionnaires>;
}
export interface Dossier {
    'uid'?: string;
    'etapeDossier'?: string;
    'reference'?: string;
    'type'?: string;
    'activityDomain'?: string;
    'planExistant'?: PlanExistant;
    'dispositifs'?: Dispositifs;
    'interessement'?: Interessement;
    'participation'?: Participation;
    'compteDePrelevement'?: CompteDePrelevement;
    'abondementUnilateral'?: AbondementUnilateral;
    'tarification'?: Tarification;
    'donneesDirigeant'?: Dirigeant;
    'donneesAnnexeKYC'?: DonneesKYC;
    'rib'?: Array<string>;
    'consultationEntreprise'?: Array<string>;
    'listeBeneficiaires'?: Array<string>;
    'documentPlanExistant'?: Array<string>;
    'documentAccordInteressement'?: Array<string>;
    'documentAccordParticipation'?: Array<string>;
    'documentAccordPPV'?: Array<string>;
    'justificatifsCNIAnnexeKYC'?: Array<string>;
    'justificatifsKBisAnnexeKYC'?: Array<string>;
    'justificatifsCasParticuliers'?: Array<string>;
    'apporteurAffaire'?: ApporteurAffaire;
    'categoriesSalaries'?: CategoriesSalaries;
    'garantiesPrevoyance'?: GarantiesPrevoyance;
    'fraisContrat'?: FraisContrat;
    'archiveDate'?: string;
    'archiveDossierAmundi'?: string;
    'messageErreurAmundi'?: string;
}
export interface DossierAvecEntreprise {
    'entreprise': Entreprise;
    'dossier': Dossier;
    'utilisateur'?: Utilisateur;
    'liasse'?: LiasseSouscription;
}
export interface DossierAvecEntrepriseRecap {
    'dossier': DossierRecap;
    'dirigeant': DirigeantRecap;
}
export interface DossierRecap {
    'uid'?: string;
    'etapeDossier'?: string;
    'reference'?: string;
    'type'?: string;
    'apporteurAffaire'?: ApporteurAffaire;
    'telephone'?: string;
    'donneesEntreprise'?: EntrepriseRecap;
    'dateCreation'?: string;
    'dateUpdate'?: string;
    'transfertPlan'?: string;
    'archiveDate'?: string;
    'messageErreurAmundi'?: string;
}
export interface DossierUid {
    'uid'?: string;
}
export interface Duration {
    'years'?: number;
    'startDate'?: string;
    'endDate'?: string;
    'tacitRenewal'?: boolean;
}
export interface Employee {
    'id': string;
    'nom': string;
    'prenom': string;
    'consentS3'?: string;
    'consentValid'?: boolean;
}
export interface Entreprise {
    'uid'?: string;
    'nouveauClient'?: boolean;
    'siret': string;
    'siren'?: string;
    'rna'?: string;
    'autreIdentifiant'?: string;
    'autreFormeJuridique'?: string;
    'raisonSociale': string;
    'dateCreation': string;
    'codeNaf': string;
    'formeJuridique': string;
    'adresse': Adresse;
    'uidDirigeant': string;
    'fonctionDuDirigeant'?: string;
    'statuts'?: Array<string>;
    'delegationPouvoir'?: Array<string>;
    'justificatifIdentiteEntreprise'?: Array<string>;
    'justificatifRecepDeclaPref'?: Array<string>;
    'justificatifRecepInsertion'?: Array<string>;
    'justificatifDecretReco'?: Array<string>;
    'justificatifCartePro'?: Array<string>;
    'nombreSalaries'?: number;
    'dateClotureComptable'?: string;
    'dateClotureComptableWithYear'?: string;
}
export interface EntrepriseRecap {
    'raisonSociale'?: string;
    'siret'?: string;
    'nombreSalaries'?: string;
}
export interface EtapeDossier {
    'etape'?: string;
}
export interface EventData {
    'metadatas'?: EventMetadata;
    'datas'?: { [key: string]: any; };
}
export interface EventMetadata {
    'uid'?: string;
    'name'?: string;
    'timestamp'?: string;
    'schemaVersion'?: number;
    'nestedContext'?: string;
    'principal'?: string;
    'entityUid'?: string;
    'entityName'?: string;
}
export interface FileMetadata {
    'name'?: string;
    'mimetype'?: string;
    'size'?: number;
    'documentType'?: FileMetadataDocumentTypeEnum;
}

export const FileMetadataDocumentTypeEnum = {
    ListeBeneficiaires: 'LISTE_BENEFICIAIRES',
    PlanExistant: 'PLAN_EXISTANT',
    JustificatifsKycPersPhysique: 'JUSTIFICATIFS_KYC_PERS_PHYSIQUE',
    JustificatifsKycPersMorale: 'JUSTIFICATIFS_KYC_PERS_MORALE',
    AccordInteressement: 'ACCORD_INTERESSEMENT',
    AccordParticipation: 'ACCORD_PARTICIPATION',
    AccordPpv: 'ACCORD_PPV',
    ConsultationEntreprise: 'CONSULTATION_ENTREPRISE',
    JustificatifsCasParticuliers: 'JUSTIFICATIFS_CAS_PARTICULIERS',
    Rib: 'RIB',
    JustificatifsKyc: 'JUSTIFICATIFS_KYC',
    StatutsEntreprise: 'STATUTS_ENTREPRISE',
    JustificatifIdentiteEntreprise: 'JUSTIFICATIF_IDENTITE_ENTREPRISE',
    DelegationPouvoir: 'DELEGATION_POUVOIR',
    RecepDeclaPref: 'RECEP_DECLA_PREF',
    RecepInsertion: 'RECEP_INSERTION',
    DecretReco: 'DECRET_RECO',
    CarteProfessionnelle: 'CARTE_PROFESSIONNELLE',
    JustificatifIdentite: 'JUSTIFICATIF_IDENTITE',
    JustificatifIdentiteRecto: 'JUSTIFICATIF_IDENTITE_RECTO',
    JustificatifIdentiteVerso: 'JUSTIFICATIF_IDENTITE_VERSO',
    Passeport: 'PASSEPORT',
    Bibliotheque: 'BIBLIOTHEQUE',
    Commissions: 'COMMISSIONS',
    PerformancesCumulees: 'PERFORMANCES_CUMULEES',
} as const;

export type FileMetadataDocumentTypeEnum = typeof FileMetadataDocumentTypeEnum[keyof typeof FileMetadataDocumentTypeEnum];

export interface FileUrl {
    'url'?: string;
}
export interface FolderUids {
    'values'?: Array<string>;
}
export interface Fonction {
    'fonction'?: string;
    'uidEntreprise'?: string;
}
export interface Formations {
    'id'?: number;
    'title'?: string;
    'icon'?: string;
    'displayed_order'?: number;
    'videos'?: Array<FormationsVideos>;
}
export interface FormationsVideos {
    'id'?: number;
    'section_id'?: number;
    'title'?: string;
    'subtitle'?: string;
    'speakers'?: string;
    'description'?: string;
    'duration'?: number;
    'link'?: string;
    'displayed_order'?: number;
}
export interface FraisContrat {
    'commisionnementEscompte': boolean;
    'tauxFraisCotisationsObligatoires': number;
    'tauxFraisVersementsVolontaires': number;
    'fraisDossier': number;
    'tauxDerogationFraisEuros'?: number;
    'tauxDerogationFraisUC'?: number;
    'tauxDerogationFraisTransfert'?: number;
}
export interface FraisRepartition {
    'repartitionEntreprise'?: number;
    'repartitionBeneficiaire'?: number;
}
export interface FraisTypeVersement {
    'participation'?: string;
    'interessement'?: string;
    'versementsVolontaires'?: string;
    'versementsComplementaires'?: string;
    'versementCET'?: string;
    'versementPPV'?: string;
}
/**
 * Requête de login pour générer les tokens Galaxy
 */
export interface GalaxyLoginRequest {
    /**
     * Token de rafraîchissement (optionnel)
     */
    'refreshToken'?: string;
}
/**
 * Réponse contenant les tokens Galaxy après authentification
 */
export interface GalaxyTokenResponse {
    /**
     * Token d\'accès Galaxy JWT signé RS256
     */
    'accessToken': string;
    /**
     * Token d\'identité Galaxy JWT signé RS256
     */
    'idToken': string;
    /**
     * Token d\'accès Auth0 original
     */
    'auth0AccessToken'?: string;
    /**
     * Token de rafraîchissement
     */
    'refreshToken'?: string;
    /**
     * Durée de validité du token en secondes
     */
    'expiresIn': number;
    /**
     * Timestamp d\'expiration du token en millisecondes
     */
    'expiresAt': number;
}
export interface GammeFonds {
    'liensGammeFonds'?: Array<LienGammeFonds>;
}
export interface GarantiesPrevoyance {
    'auMoinsCinqSalaries'?: boolean;
    'garantiePlancher': boolean;
    'garantieDeBonneFin': boolean;
}
export interface GeneratorData {
    'sectorName'?: string;
    'criteria'?: Array<Criterion>;
    'companyInfo'?: CompanyInfo;
    'agreementDetails'?: AgreementDetails;
    'bonus'?: Bonus;
    'simulationDate'?: string;
}
export interface GeneratorDataList extends Array<GeneratorData> {
}
export interface Groupe {
    'id'?: string;
    'name'?: string;
    'codeReseau'?: string;
    'codePortefeuille'?: string;
}
export interface Groupes extends Array<Groupe> {
}
export interface InfoBanner {
    'id'?: string;
    'text'?: string;
    'activated'?: boolean;
}
export interface InitDossier {
    'activityDomain'?: InitDossierActivityDomainEnum;
    'dirigeant': InitDossierDirigeant;
    'entreprise': InitDossierEntreprise;
    'simulateur'?: InitDossierSimulateur;
    'forceSiret': boolean;
    'telephone': string;
    'indicatif': string;
}

export const InitDossierActivityDomainEnum = {
    Empty: '',
    Maroquinerie: 'MAROQUINERIE',
} as const;

export type InitDossierActivityDomainEnum = typeof InitDossierActivityDomainEnum[keyof typeof InitDossierActivityDomainEnum];

export interface InitDossierDirigeant {
    'nom': string;
    'prenom': string;
}
export interface InitDossierEntreprise {
    'siret'?: string;
}
export interface InitDossierSimulateur {
    'nomEntreprise'?: string;
    'nombreSalaries'?: number;
    'PEE'?: SimulateurPlan;
    'PERCO'?: SimulateurPlan;
    'abondementUnilateral'?: number;
    'interessement'?: InitDossierSimulateurInteressement;
    'participation'?: InitDossierSimulateurInteressement;
}
export interface InitDossierSimulateurInteressement {
    'montant'?: number;
    'repartition'?: SimulateurRepartitionDetail;
}
export interface Inspecteur {
    'id'?: string;
    'name'?: string;
    'groupe'?: Groupe;
}
export interface Inspecteurs extends Array<Inspecteur> {
}
export interface Interessement {
    'interessementActive'?: boolean;
}
export interface LiasseSouscription {
    'uid'?: string;
    'uidDossierSouscription'?: string;
    'statut'?: string;
    'statutDate'?: string;
    'documents'?: Array<string>;
}
export interface LienGammeFonds {
    'id'?: number;
    'type'?: string;
    'nom'?: string;
    'isin'?: string;
    'typologie'?: string;
    'sri'?: string;
    'horizonPlacement'?: string;
    'dic'?: string;
}
export interface LieuExercice {
    'france'?: boolean;
    'ue'?: string;
    'horsUe'?: string;
}
export interface ListInfoBanners {
    'listInfoBanners'?: Array<InfoBanner>;
}
export interface ListeActivity extends Array<Activity> {
}
export interface ListeCustomTunnels extends Array<CustomTunnelData> {
}
export interface ListePays extends Array<Pays> {
}
export interface Modalites {
    'dateEffet'?: string;
}
export interface OptionParticipation {
    'enabled'?: boolean;
    'type'?: number;
    'repartition'?: OptionParticipationRepartition;
    'duree'?: OptionParticipationDuree;
    'applicationFiscale'?: string;
}
export interface OptionParticipationDuree {
    'type'?: number;
    'duree'?: number;
}
export interface OptionParticipationRepartition {
    'type'?: number;
    'pourcent'?: SimulateurRepartitionDetailPourcent;
}
export interface PalierAbondement {
    'taux': number;
    'versementMin': number;
    'versementMax': number;
}
export interface PalierAncienneteAbondement {
    'taux': number;
    'plafond1an': number;
    'plafond3an': number;
    'plafond5an': number;
    'plafondMax': number;
}
export interface Participation {
    'participationActive'?: boolean;
    'optionParticipation'?: OptionParticipation;
}
export interface Pass {
    'currentPass'?: number;
    'prevPass'?: number;
}
export interface Pays {
    'nom'?: string;
    'code'?: string;
    'codeInsee'?: string;
}
export interface PaysActivite {
    'pays'?: Pays;
    'chiffreAffaire'?: number;
}
export interface Periodicite {
    'option'?: number;
    'trimestre'?: number;
}
export interface Permission {
    'id'?: string;
    'name'?: string;
    'description'?: string;
}
export interface Permissions extends Array<Permission> {
}
export interface PlanExistant {
    'hasPlanExistant'?: boolean;
    'prestataireTenuDeCompte'?: string;
    'avoirPee'?: boolean;
    'avoirPerco'?: boolean;
    'avoirInteressement'?: boolean;
    'avoirParticipation'?: boolean;
    'transfertPlan'?: boolean;
    'accordInteressementEnPlace'?: boolean;
    'accordParticipationEnPlace'?: boolean;
    'accordPPVEnPlace'?: boolean;
}
export interface RecapCommission {
    'id'?: string;
    'sourceCommissionId'?: string;
    'mois'?: string;
    'codeApporteur'?: string;
    'totalVerseDistributeurs'?: number;
    'dateCreation'?: string;
}
export interface Regulateur {
    'nomRegulateur'?: string;
    'referenceAgrement'?: string;
}
export interface Role {
    'id'?: string;
    'name'?: string;
}
export interface RoleDansEntreprise {
    'entrepriseUid'?: string;
    'role'?: string;
    'fonction'?: string;
}
export interface Roles extends Array<Role> {
}
export interface ServiceActivation {
    'name'?: string;
    'isServiceActive'?: boolean;
    'updateDate'?: string;
}
export interface SimulateurPlan {
    'repartition'?: SimulateurPlanRepartitionEnum;
    'sources'?: Array<SimulateurPlanSourcesEnum>;
    'plafonds'?: SimulateurPlanPlafonds;
    'paliers'?: Array<SimulateurPlanPaliersInner>;
}

export const SimulateurPlanRepartitionEnum = {
    Versement: 'versement',
    Anciennete: 'anciennete',
} as const;

export type SimulateurPlanRepartitionEnum = typeof SimulateurPlanRepartitionEnum[keyof typeof SimulateurPlanRepartitionEnum];
export const SimulateurPlanSourcesEnum = {
    VersementVolontaire: 'VERSEMENT_VOLONTAIRE',
    Interessement: 'INTERESSEMENT',
    Participation: 'PARTICIPATION',
    JoursCet: 'JOURS_CET',
} as const;

export type SimulateurPlanSourcesEnum = typeof SimulateurPlanSourcesEnum[keyof typeof SimulateurPlanSourcesEnum];

export interface SimulateurPlanPaliersInner {
    'taux'?: number;
    'min'?: number;
    'max'?: number;
}
export interface SimulateurPlanPlafonds {
    'taux'?: number;
    'plafond1an'?: number;
    'plafond3an'?: number;
    'plafond5an'?: number;
    'plafondMax'?: number;
}
export interface SimulateurRepartitionDetail {
    'type'?: number;
    'pourcent'?: SimulateurRepartitionDetailPourcent;
}
export interface SimulateurRepartitionDetailPourcent {
    'uniforme'?: number;
    'salaire'?: number;
    'temps'?: number;
}
export interface SireneInfo {
    'raisonSociale'?: string;
    'siren'?: string;
    'siret'?: string;
    'codeNaf'?: string;
    'formeJuridique'?: string;
    'dateCreation'?: string;
    'adresse'?: Adresse;
}
export interface SourceCommissions {
    'id'?: string;
    'trimestre'?: SourceCommissionsTrimestreEnum;
    'annee'?: number;
    'nomOriginal'?: string;
    'cheminCompletS3'?: string;
    'statutTraitement'?: SourceCommissionsStatutTraitementEnum;
    'messageErreur'?: string;
    'dateAjout'?: string;
    'dateDerniereModification'?: string;
}

export const SourceCommissionsTrimestreEnum = {
    T1: 'T1',
    T2: 'T2',
    T3: 'T3',
    T4: 'T4',
} as const;

export type SourceCommissionsTrimestreEnum = typeof SourceCommissionsTrimestreEnum[keyof typeof SourceCommissionsTrimestreEnum];
export const SourceCommissionsStatutTraitementEnum = {
    EnCours: 'EN_COURS',
    Succes: 'SUCCES',
    Erreur: 'ERREUR',
} as const;

export type SourceCommissionsStatutTraitementEnum = typeof SourceCommissionsStatutTraitementEnum[keyof typeof SourceCommissionsStatutTraitementEnum];

export interface SubscriptionConsents {
    'raisonSociale'?: string;
    'siren'?: string;
    'refInterne'?: string;
    'refExterne'?: string;
    'codeApporteurAmundi'?: string;
    'statutEntreprise'?: string;
    'salaries'?: Array<Employee>;
}
export interface Tarification {
    'fraisEntree': number;
    'fraisDossier': number;
    'fraisConseil'?: number;
    'iban': string;
    'bic'?: string;
    'ciblePrelevements'?: string;
    'applicationFraisConseil'?: boolean;
    'optionChargeFrais'?: number;
    'fraisRepartition'?: FraisRepartition;
    'fraisTypeVersement'?: FraisTypeVersement;
}
export interface TemplateMail {
    'template'?: string;
}
export interface Token {
    'jwt': string;
    'dirigeantUid': string;
    'entrepriseUid': string;
    'dossierUid': string;
}
export interface TokenSso {
    'sso'?: string;
}
export interface UploadUrl {
    'url'?: string;
}
export interface UrlSignature {
    'url'?: string;
}
export interface Utilisateur {
    'uid'?: string;
    'civilite'?: Civilite;
    'nom': string;
    'prenom': string;
    'nomNaissance'?: string;
    'adresseEmail': string;
    'indicatifCode'?: string;
    'telephone'?: string;
    'roleDansEntreprise'?: Array<RoleDansEntreprise>;
    'paysNaissance'?: Pays;
    'paysResidence'?: Pays;
    'nir'?: string;
    'dateNaissance'?: string;
    'adresse'?: Adresse;
    'adresseNaissance'?: Adresse;
    'nationalites'?: string;
    'justificatifIdentite'?: Array<string>;
    'justificatifIdentiteRecto'?: Array<string>;
    'justificatifIdentiteVerso'?: Array<string>;
    'passeport'?: Array<string>;
}



/**
 * AuthenticationApi - axios parameter creator
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Authentifie un apporteur via son token Auth0 et génère les tokens Galaxy (access_token, id_token). Le token Auth0 doit être passé dans le header Authorization. L\'ID Auth0 de l\'utilisateur doit être passé dans le header X-Auth0-User-Id. 
         * @summary Authentification et génération des tokens Galaxy
         * @param {string} xAuth0UserId ID Auth0 de l\&#39;utilisateur (avec ou sans le préfixe \&quot;auth0|\&quot;)
         * @param {GalaxyLoginRequest} [galaxyLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        galaxyLogin: async (xAuth0UserId: string, galaxyLoginRequest?: GalaxyLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xAuth0UserId' is not null or undefined
            assertParamExists('galaxyLogin', 'xAuth0UserId', xAuth0UserId)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            if (xAuth0UserId != null) {
                localVarHeaderParameter['X-Auth0-User-Id'] = String(xAuth0UserId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(galaxyLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * Authentifie un apporteur via son token Auth0 et génère les tokens Galaxy (access_token, id_token). Le token Auth0 doit être passé dans le header Authorization. L\'ID Auth0 de l\'utilisateur doit être passé dans le header X-Auth0-User-Id. 
         * @summary Authentification et génération des tokens Galaxy
         * @param {string} xAuth0UserId ID Auth0 de l\&#39;utilisateur (avec ou sans le préfixe \&quot;auth0|\&quot;)
         * @param {GalaxyLoginRequest} [galaxyLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async galaxyLogin(xAuth0UserId: string, galaxyLoginRequest?: GalaxyLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GalaxyTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.galaxyLogin(xAuth0UserId, galaxyLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.galaxyLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * Authentifie un apporteur via son token Auth0 et génère les tokens Galaxy (access_token, id_token). Le token Auth0 doit être passé dans le header Authorization. L\'ID Auth0 de l\'utilisateur doit être passé dans le header X-Auth0-User-Id. 
         * @summary Authentification et génération des tokens Galaxy
         * @param {string} xAuth0UserId ID Auth0 de l\&#39;utilisateur (avec ou sans le préfixe \&quot;auth0|\&quot;)
         * @param {GalaxyLoginRequest} [galaxyLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        galaxyLogin(xAuth0UserId: string, galaxyLoginRequest?: GalaxyLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<GalaxyTokenResponse> {
            return localVarFp.galaxyLogin(xAuth0UserId, galaxyLoginRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * Authentifie un apporteur via son token Auth0 et génère les tokens Galaxy (access_token, id_token). Le token Auth0 doit être passé dans le header Authorization. L\'ID Auth0 de l\'utilisateur doit être passé dans le header X-Auth0-User-Id. 
     * @summary Authentification et génération des tokens Galaxy
     * @param {string} xAuth0UserId ID Auth0 de l\&#39;utilisateur (avec ou sans le préfixe \&quot;auth0|\&quot;)
     * @param {GalaxyLoginRequest} [galaxyLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public galaxyLogin(xAuth0UserId: string, galaxyLoginRequest?: GalaxyLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).galaxyLogin(xAuth0UserId, galaxyLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary active specified folders
         * @param {FolderUids} folderUids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activeFolders: async (folderUids: FolderUids, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderUids' is not null or undefined
            assertParamExists('activeFolders', 'folderUids', folderUids)
            const localVarPath = `/dossiers/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(folderUids, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ajout d\'un commentaire sur un dossier
         * @param {Commentaire} commentaire 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommentaireDossier: async (commentaire: Commentaire, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commentaire' is not null or undefined
            assertParamExists('addCommentaireDossier', 'commentaire', commentaire)
            const localVarPath = `/donnees/commentaire-dossier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentaire, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Annulation d\'une liasse de souscription
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annulerLiasse: async (uid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('annulerLiasse', 'uid', uid)
            const localVarPath = `/liassesSouscription/{uid}`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive specified folders
         * @param {FolderUids} folderUids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveFolders: async (folderUids: FolderUids, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderUids' is not null or undefined
            assertParamExists('archiveFolders', 'folderUids', folderUids)
            const localVarPath = `/dossiers/archive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(folderUids, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verification de cookie valide sinon retour des cgu en html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCgu: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contributeurs/checkCguValidated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain; charset=utf-8,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Connexion à une session avec le token sso
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connecterSSO: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contributeurs/ssoIn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Envoi des données du formulaire de contact
         * @param {ContactData} contactData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactData: async (contactData: ContactData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactData' is not null or undefined
            assertParamExists('contactData', 'contactData', contactData)
            const localVarPath = `/donnees/profit-sharing-generator/contact-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Création d\'un nouveau apporteur
         * @param {ApporteurLight} [apporteurLight] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApporteur: async (apporteurLight?: ApporteurLight, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/apporteurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apporteurLight, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary création d\'un document de la section de la bibliotheque
         * @param {string} idSection 
         * @param {BibliothequeDocument} [bibliothequeDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBibliothequeDocument: async (idSection: string, bibliothequeDocument?: BibliothequeDocument, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSection' is not null or undefined
            assertParamExists('createBibliothequeDocument', 'idSection', idSection)
            const localVarPath = `/bibliotheque/section/{idSection}`
                .replace(`{${"idSection"}}`, encodeURIComponent(String(idSection)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bibliothequeDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ajout d\'une section de la bibliotheque
         * @param {BibliothequeSection} bibliothequeSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBibliothequeSection: async (bibliothequeSection: BibliothequeSection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bibliothequeSection' is not null or undefined
            assertParamExists('createBibliothequeSection', 'bibliothequeSection', bibliothequeSection)
            const localVarPath = `/bibliotheque/sections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bibliothequeSection, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Création d\'un nouveau groupe (réseau apporteur)
         * @param {Groupe} groupe 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroupe: async (groupe: Groupe, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupe' is not null or undefined
            assertParamExists('createGroupe', 'groupe', groupe)
            const localVarPath = `/auth/groupes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupe, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Création d\'un nouvel inspecteur
         * @param {Inspecteur} inspecteur 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInspecteur: async (inspecteur: Inspecteur, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inspecteur' is not null or undefined
            assertParamExists('createInspecteur', 'inspecteur', inspecteur)
            const localVarPath = `/auth/inspecteurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inspecteur, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Création de la liasse de souscription
         * @param {DossierUid} dossierUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creerLiasseSouscription: async (dossierUid: DossierUid, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossierUid' is not null or undefined
            assertParamExists('creerLiasseSouscription', 'dossierUid', dossierUid)
            const localVarPath = `/liassesSouscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dossierUid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression d\'une liste d\'apporteurs
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApporteurs: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/apporteurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification d\'un article de news
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticle: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteArticle', 'id', id)
            const localVarPath = `/articles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary suppression d\'un document de la bibliotheque
         * @param {string} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBibliothequeDocument: async (idDocument: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('deleteBibliothequeDocument', 'idDocument', idDocument)
            const localVarPath = `/bibliotheque/document/{idDocument}`
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary suppression d\'une section de la bibliotheque
         * @param {number} idSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBibliothequeSection: async (idSection: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSection' is not null or undefined
            assertParamExists('deleteBibliothequeSection', 'idSection', idSection)
            const localVarPath = `/bibliotheque/section/{idSection}`
                .replace(`{${"idSection"}}`, encodeURIComponent(String(idSection)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression d\'un commentaire sur un dossier
         * @param {string} dossierUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommentaireDossier: async (dossierUid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossierUid' is not null or undefined
            assertParamExists('deleteCommentaireDossier', 'dossierUid', dossierUid)
            const localVarPath = `/donnees/commentaire-dossier/{dossierUid}`
                .replace(`{${"dossierUid"}}`, encodeURIComponent(String(dossierUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression du fichier de consentement pour l\'utilisateur
         * @param {string} refInterne 
         * @param {string} idEmployee 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConsent: async (refInterne: string, idEmployee: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refInterne' is not null or undefined
            assertParamExists('deleteConsent', 'refInterne', refInterne)
            // verify required parameter 'idEmployee' is not null or undefined
            assertParamExists('deleteConsent', 'idEmployee', idEmployee)
            const localVarPath = `/consentements/file/{refInterne}/{idEmployee}`
                .replace(`{${"refInterne"}}`, encodeURIComponent(String(refInterne)))
                .replace(`{${"idEmployee"}}`, encodeURIComponent(String(idEmployee)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary suppression du fichier d\'un document de la bibliotheque
         * @param {string} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentFile: async (idDocument: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('deleteDocumentFile', 'idDocument', idDocument)
            const localVarPath = `/bibliotheque/document/file/{idDocument}`
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression d\'un lien de la gamme de fonds
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGammeFondsLien: async (linkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('deleteGammeFondsLien', 'linkId', linkId)
            const localVarPath = `/gammeFonds/lien/{linkId}`
                .replace(`{${"linkId"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression d\'un bandeau d\'informations
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInfoBanner: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteInfoBanner', 'id', id)
            const localVarPath = `/infoBanners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression du justificatif \'Carte professionnelle\' (profession libérale)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageCarteProfessionnelle: async (uid: string, nom?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('deletePageCarteProfessionnelle', 'uid', uid)
            const localVarPath = `/entreprises/{uid}/justificatifCarteProfessionnelle`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression du justificatif \'Copie du décret de reconnaissance de l’utilité publique\' (association)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageDecretReco: async (uid: string, nom?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('deletePageDecretReco', 'uid', uid)
            const localVarPath = `/entreprises/{uid}/justificatifDecretReco`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression du Delegation du pouvoir
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageDelegationPouvoir: async (uid: string, nom?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('deletePageDelegationPouvoir', 'uid', uid)
            const localVarPath = `/entreprises/{uid}/delegationPouvoir`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression d\'une page d\'une pièce justificative de dossier de souscription
         * @param {string} uid UID du dossier de souscription
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageDocument: async (uid: string, fileMetadata: FileMetadata, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('deletePageDocument', 'uid', uid)
            // verify required parameter 'fileMetadata' is not null or undefined
            assertParamExists('deletePageDocument', 'fileMetadata', fileMetadata)
            const localVarPath = `/dossiers/{uid}/update-justificatifs`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileMetadata, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression d\'un justificatif d\'identité
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageJustificatifIdentite: async (uid: string, nom?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('deletePageJustificatifIdentite', 'uid', uid)
            const localVarPath = `/utilisateurs/{uid}/justificatifIdentite`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression d\'une page du justificatif de l\'entreprise
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageJustificatifIdentiteEntreprise: async (uid: string, nom?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('deletePageJustificatifIdentiteEntreprise', 'uid', uid)
            const localVarPath = `/entreprises/{uid}/justificatifIdentiteEntreprise`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression d\'un côté d\'un justificatif d\'identité
         * @param {string} uid 
         * @param {boolean} isRecto 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageJustificatifIdentite_1: async (uid: string, isRecto: boolean, nom?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('deletePageJustificatifIdentite_1', 'uid', uid)
            // verify required parameter 'isRecto' is not null or undefined
            assertParamExists('deletePageJustificatifIdentite_1', 'isRecto', isRecto)
            const localVarPath = `/utilisateurs/{uid}/justificatifIdentite/{isRecto}/`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)))
                .replace(`{${"isRecto"}}`, encodeURIComponent(String(isRecto)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression d\'un justificatif d\'identité (passeport)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePagePasseport: async (uid: string, nom?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('deletePagePasseport', 'uid', uid)
            const localVarPath = `/utilisateurs/{uid}/passeport`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression du justificatif \'Récépissé de déclaration en préfecture\' (association)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageRecepDeclaPref: async (uid: string, nom?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('deletePageRecepDeclaPref', 'uid', uid)
            const localVarPath = `/entreprises/{uid}/justificatifRecepDeclaPref`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression du justificatif \'Récépissé d’insertion légale au Journal Officiel\' (association)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageRecepInsertion: async (uid: string, nom?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('deletePageRecepInsertion', 'uid', uid)
            const localVarPath = `/entreprises/{uid}/justificatifRecepInsertion`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression d\'une page des statuts de l\'entreprise
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageStatuts: async (uid: string, nom?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('deletePageStatuts', 'uid', uid)
            const localVarPath = `/entreprises/{uid}/statuts`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suppression des données d\'un fichier source des commissions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSourceCommissions: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSourceCommissions', 'id', id)
            const localVarPath = `/source-commissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Création d\'une entreprise et initialisation d\'un dossier
         * @param {Entreprise} entreprise 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enregistrerEntreprise: async (entreprise: Entreprise, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entreprise' is not null or undefined
            assertParamExists('enregistrerEntreprise', 'entreprise', entreprise)
            const localVarPath = `/entreprises`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entreprise, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permet de transmettre le bulletin d\'adhésion au client par mail
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        envoiMailAvantSignature: async (uid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('envoiMailAvantSignature', 'uid', uid)
            const localVarPath = `/dossiers/{uid}/mail-bulletin-avant-signature`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Génération d\'un token SSO pour le portail GES
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genererTokenSso: async (uid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('genererTokenSso', 'uid', uid)
            const localVarPath = `/dossiers/{uid}/sso`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all active subscription folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActiveFolders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dossiers/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération de toutes les activités présentes en base de données
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActivities: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/donnees/profit-sharing-generator/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des apporteurs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllApporteurs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/apporteurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all archived subscription folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllArchivedFolders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dossiers/archive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération de tous les consentements contenant à minima un fichier de consentement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConsents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/consentements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des consentements de l\'apporteur d\'affaire (du token ou spécifié)
         * @param {string} [codeApporteur] Code de l\&#39;apporteur d\&#39;affaire. Si non fourni, utilise le code du bearer token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConsentsByBusinessProvider: async (codeApporteur?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/consentements/apporteur`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (codeApporteur !== undefined) {
                localVarQueryParameter['codeApporteur'] = codeApporteur;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des groupes (= réseaux apporteurs)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGroupes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/groupes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des inspecteurs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInspecteurs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/inspecteurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des sections de la bibliothèque ainsi que des documents associés
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSections: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bibliotheque/sections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * L\'user_id auth0 de l\'apporteur à récupérer est stocké dans le Bearer token, dans la propriété sub
         * @summary Récupération des données d\'un apporteur pour l\'authentification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApporteurByAuthId: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/apporteurs/auth0/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération d\'un document d\'actualité du portail
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleDocument: async (filename: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('getArticleDocument', 'filename', filename)
            const localVarPath = `/articles/file/{filename}`
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des articles des news
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/articles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'Application/json,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération d\'une section de la bibliotheque
         * @param {number} idSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBibliothequeSection: async (idSection: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSection' is not null or undefined
            assertParamExists('getBibliothequeSection', 'idSection', idSection)
            const localVarPath = `/bibliotheque/section/{idSection}`
                .replace(`{${"idSection"}}`, encodeURIComponent(String(idSection)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération du commentaire lié à un dossier
         * @param {string} dossierUid La référence du dossier pour lequel on veut le commentaire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentaireDossier: async (dossierUid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossierUid' is not null or undefined
            assertParamExists('getCommentaireDossier', 'dossierUid', dossierUid)
            const localVarPath = `/donnees/commentaire-dossier/{dossierUid}`
                .replace(`{${"dossierUid"}}`, encodeURIComponent(String(dossierUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des commissions liées à un trimestre et un code apporteur
         * @param {string} annee 
         * @param {string} trimestre 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommissionByQuarter: async (annee: string, trimestre: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'annee' is not null or undefined
            assertParamExists('getCommissionByQuarter', 'annee', annee)
            // verify required parameter 'trimestre' is not null or undefined
            assertParamExists('getCommissionByQuarter', 'trimestre', trimestre)
            const localVarPath = `/commissions/{annee}/{trimestre}`
                .replace(`{${"annee"}}`, encodeURIComponent(String(annee)))
                .replace(`{${"trimestre"}}`, encodeURIComponent(String(trimestre)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération de la liste des commissions d\'un apporteur sous forme de tableau Excel
         * @param {string} annee 
         * @param {string} trimestre 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommissionsFile: async (annee: string, trimestre: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'annee' is not null or undefined
            assertParamExists('getCommissionsFile', 'annee', annee)
            // verify required parameter 'trimestre' is not null or undefined
            assertParamExists('getCommissionsFile', 'trimestre', trimestre)
            const localVarPath = `/commissions/file/{annee}/{trimestre}`
                .replace(`{${"annee"}}`, encodeURIComponent(String(annee)))
                .replace(`{${"trimestre"}}`, encodeURIComponent(String(trimestre)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des informations d\'une entreprise depuis son SIRET
         * @param {string} siret Le numéro SIRET de l\&#39;entreprise
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyInfo: async (siret: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siret' is not null or undefined
            assertParamExists('getCompanyInfo', 'siret', siret)
            const localVarPath = `/donnees/profit-sharing-generator/company-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (siret !== undefined) {
                localVarQueryParameter['siret'] = siret;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération d\'un dossier de consentement par sa référence Interne
         * @param {string} refInterne 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentByRefInterne: async (refInterne: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refInterne' is not null or undefined
            assertParamExists('getConsentByRefInterne', 'refInterne', refInterne)
            const localVarPath = `/consentements/detail/{refInterne}`
                .replace(`{${"refInterne"}}`, encodeURIComponent(String(refInterne)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération du document de consentement d\'un des salariés pour la visualisation du back office
         * @param {string} refInterne 
         * @param {string} idEmployee 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentFileToPreview: async (refInterne: string, idEmployee: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refInterne' is not null or undefined
            assertParamExists('getConsentFileToPreview', 'refInterne', refInterne)
            // verify required parameter 'idEmployee' is not null or undefined
            assertParamExists('getConsentFileToPreview', 'idEmployee', idEmployee)
            const localVarPath = `/consentements/file/{refInterne}/{idEmployee}`
                .replace(`{${"refInterne"}}`, encodeURIComponent(String(refInterne)))
                .replace(`{${"idEmployee"}}`, encodeURIComponent(String(idEmployee)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération du document pdf du modèle pour le consentement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentModel: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/consentements/models/consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération de la liste des pays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/donnees/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des critères de financiers, qualitatifs et RSE associés à un id de secteur d\'activité
         * @param {number} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriteria: async (activityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('getCriteria', 'activityId', activityId)
            const localVarPath = `/donnees/profit-sharing-generator/criteria/{activityId}`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération de la liste des tunnels personnalisés
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomTunnels: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/gerer-tunnels/custom-tunnels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération d\'un fichier à un document de la bibliothèque
         * @param {string} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentFile: async (idDocument: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('getDocumentFile', 'idDocument', idDocument)
            const localVarPath = `/bibliotheque/document/file/{idDocument}`
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération du dossier de souscription
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDossier: async (uid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('getDossier', 'uid', uid)
            const localVarPath = `/dossiers/{uid}`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des documents contractuels d\'un dossier
         * @param {string} dossierUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDossierContractDocuments: async (dossierUid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossierUid' is not null or undefined
            assertParamExists('getDossierContractDocuments', 'dossierUid', dossierUid)
            const localVarPath = `/dossiers/{dossierUid}/contract-documents`
                .replace(`{${"dossierUid"}}`, encodeURIComponent(String(dossierUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération du dossier de souscription complet
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDossierDetails: async (uid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('getDossierDetails', 'uid', uid)
            const localVarPath = `/dossiers/{uid}/details`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des informations de l\'entreprise
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntreprise: async (uid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('getEntreprise', 'uid', uid)
            const localVarPath = `/entreprises/{uid}`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des évènements du domaine Plan Epargne Salarial selon différents critères
         * @param {string} [dateDebut] Recherche des évènements à partir de cette date / Format -&gt; jj/MM/YYYY
         * @param {string} [dateFin] Recherche des évènements jusqu\&#39;à cette date / Format -&gt; jj/MM/YYYY
         * @param {string} [entityName] Nom de l\&#39;entité concerné par l\&#39;évènement.
         * @param {string} [entityUid] uid de l\&#39;entité concernée par l\&#39;évènement. Il se trouve dans les metadatas
         * @param {string} [eventType] Nom de l\&#39;évènement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsPlan: async (dateDebut?: string, dateFin?: string, entityName?: string, entityUid?: string, eventType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/events/plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateDebut !== undefined) {
                localVarQueryParameter['dateDebut'] = dateDebut;
            }

            if (dateFin !== undefined) {
                localVarQueryParameter['dateFin'] = dateFin;
            }

            if (entityName !== undefined) {
                localVarQueryParameter['entityName'] = entityName;
            }

            if (entityUid !== undefined) {
                localVarQueryParameter['entityUid'] = entityUid;
            }

            if (eventType !== undefined) {
                localVarQueryParameter['eventType'] = eventType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des évènements du domaine Référentiel Organisationnel selon différents critères
         * @param {string} [dateDebut] Recherche des évènements à partir de cette date / Format -&gt; jj/MM/YYYY
         * @param {string} [dateFin] Recherche des évènements jusqu\&#39;à cette date / Format -&gt; jj/MM/YYYY
         * @param {string} [entityName] Nom de l\&#39;entité concerné par l\&#39;évènement.
         * @param {string} [entityUid] uid de l\&#39;entité concernée par l\&#39;évènement. Il se trouve dans les metadatas
         * @param {string} [eventType] Nom de l\&#39;évènement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsReferentielOrga: async (dateDebut?: string, dateFin?: string, entityName?: string, entityUid?: string, eventType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/events/refOrga`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateDebut !== undefined) {
                localVarQueryParameter['dateDebut'] = dateDebut;
            }

            if (dateFin !== undefined) {
                localVarQueryParameter['dateFin'] = dateFin;
            }

            if (entityName !== undefined) {
                localVarQueryParameter['entityName'] = entityName;
            }

            if (entityUid !== undefined) {
                localVarQueryParameter['entityUid'] = entityUid;
            }

            if (eventType !== undefined) {
                localVarQueryParameter['eventType'] = eventType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération d\'un fichier du dossier custom_tunnels du S3
         * @param {string} reseau 
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile: async (reseau: string, filename: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reseau' is not null or undefined
            assertParamExists('getFile', 'reseau', reseau)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('getFile', 'filename', filename)
            const localVarPath = `/gerer-tunnels/{reseau}/files/{filename}`
                .replace(`{${"reseau"}}`, encodeURIComponent(String(reseau)))
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération de données de la rubrique \'Formations\' du portail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/formations/liste`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération d\'un URL vers le S3 pour la vidéo
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormationsUrl: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getFormationsUrl', 'name', name)
            const localVarPath = `/formations/url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des liens de la gamme de fonds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGammeFonds: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/gammeFonds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Envoie des données de la simulation d\'intéressement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorDatas: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/donnees/profit-sharing-generator/simulation-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des bandeaux d\'informations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfoBanners: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/infoBanners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération valeurs du PASS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPASS: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/donnees/pass`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération du document pdf pour les Performances cumulées
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerformancesCumulees: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/donnees/performancesCumulees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Requête une URL signée d\'upload AWS pour l\'ajout d\'un fichier de source commissions
         * @param {string} id 
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresignedUploadURLForCommissionsFile: async (id: string, fileMetadata: FileMetadata, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPresignedUploadURLForCommissionsFile', 'id', id)
            // verify required parameter 'fileMetadata' is not null or undefined
            assertParamExists('getPresignedUploadURLForCommissionsFile', 'fileMetadata', fileMetadata)
            const localVarPath = `/source-commissions/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileMetadata, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Requête une URL signée d\'upload AWS pour l\'ajout d\'un fichier dans la bibliothèque
         * @param {string} idDocument 
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresignedUploadURLForLibraryDocumentFile: async (idDocument: string, fileMetadata: FileMetadata, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('getPresignedUploadURLForLibraryDocumentFile', 'idDocument', idDocument)
            // verify required parameter 'fileMetadata' is not null or undefined
            assertParamExists('getPresignedUploadURLForLibraryDocumentFile', 'fileMetadata', fileMetadata)
            const localVarPath = `/bibliotheque/document/file/{idDocument}`
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileMetadata, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Requête une URL signée d\'upload AWS pour une page de pièce justificative de dossier de souscription
         * @param {string} uid UID du dossier de souscription
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresignedUploadURLForPageDocument: async (uid: string, fileMetadata: FileMetadata, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('getPresignedUploadURLForPageDocument', 'uid', uid)
            // verify required parameter 'fileMetadata' is not null or undefined
            assertParamExists('getPresignedUploadURLForPageDocument', 'fileMetadata', fileMetadata)
            const localVarPath = `/dossiers/{uid}/update-justificatifs`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileMetadata, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération d\'une URL présignée pour déposer le document des Performances cumulées
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresignedUploadURLForPerformancesCumulees: async (fileMetadata: FileMetadata, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileMetadata' is not null or undefined
            assertParamExists('getPresignedUploadURLForPerformancesCumulees', 'fileMetadata', fileMetadata)
            const localVarPath = `/donnees/performancesCumulees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileMetadata, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Génère un fichier excel avec le rapport de dossies de souscription du tunnel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapports: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dossiers/rapports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération de la liste des récaps des commissions d\'un apporteur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecapCommissionsApporteur: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commissions/recap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération activation du service avec son nom
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceByName: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getServiceByName', 'name', name)
            const localVarPath = `/services/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération activation des services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des données simplifiées des dossiers de souscription actifs pour un apporteur
         * @param {string} [codeApporteur] Code de l\&#39;apporteur pour filtrer les dossiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimpleActiveFolders: async (codeApporteur?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dossiers/simple/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (codeApporteur !== undefined) {
                localVarQueryParameter['codeApporteur'] = codeApporteur;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération du document zip pour le Simulateur CAMPAGNE+ de suivi d\'activité
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulateurCampagnePlus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/donnees/simulateurCampagnePlus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récuperation d\'une URL présignée d\'un fichier de source commissions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceCommissionsFile: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSourceCommissionsFile', 'id', id)
            const localVarPath = `/source-commissions/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération de la liste des fichiers sources de commissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourcesCommissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/source-commissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération de la page de template de test interprété par Thymeleaf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération du fichier excel avec le transfers plan épargne salariale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dossiers/transfertsEpargneSalariale`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des informations de l\'utilisateur
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtilisateur: async (uid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('getUtilisateur', 'uid', uid)
            const localVarPath = `/utilisateurs/{uid}`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Initialise un dossier de souscription avec les données d\'un apporteur d\'affaire
         * @param {InitDossier} [initDossier] Dossier avec apporteur d\&#39;affaire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initDossier: async (initDossier?: InitDossier, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dossiers/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initDossier, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Webhook utilisé par Docusign pour récupérer la liasse signée
         * @param {string} tenant 
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifierLiasse: async (tenant: string, uid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('notifierLiasse', 'tenant', tenant)
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('notifierLiasse', 'uid', uid)
            const localVarPath = `/liassesSouscription/{tenant}/{uid}/notifier`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enregistre en BD l\'ajout du fichier de la bibliothèque. Route appelée après qu\'un upload AWS ait réussi côté client.
         * @summary Enregistre l\'ajout d\'un fichier de la bibliothèque
         * @param {string} idDocument 
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyLibraryDocumentFileUploaded: async (idDocument: string, fileMetadata: FileMetadata, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('notifyLibraryDocumentFileUploaded', 'idDocument', idDocument)
            // verify required parameter 'fileMetadata' is not null or undefined
            assertParamExists('notifyLibraryDocumentFileUploaded', 'fileMetadata', fileMetadata)
            const localVarPath = `/bibliotheque/document/file/{idDocument}`
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileMetadata, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enregistre en BD l\'ajout de la page de la pièce justificative pour un dossier de souscription. Route appelée après qu\'un upload AWS ait réussi côté client.
         * @summary Enregistre l\'ajout de la page de la pièce justificative pour un dossier de souscription
         * @param {string} uid UID du dossier de souscription
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyPageDocumentUploaded: async (uid: string, fileMetadata: FileMetadata, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('notifyPageDocumentUploaded', 'uid', uid)
            // verify required parameter 'fileMetadata' is not null or undefined
            assertParamExists('notifyPageDocumentUploaded', 'fileMetadata', fileMetadata)
            const localVarPath = `/dossiers/{uid}/update-justificatifs`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileMetadata, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Notifie le serveur après la réussite de l\'upload du document vers AWS S3.
         * @summary Enregistrement du document des Performances cumulées après son dépôt
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyPerformancesCumuleesUploaded: async (fileMetadata: FileMetadata, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileMetadata' is not null or undefined
            assertParamExists('notifyPerformancesCumuleesUploaded', 'fileMetadata', fileMetadata)
            const localVarPath = `/donnees/performancesCumulees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileMetadata, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ajout d\'un article de news
         * @param {Article} article Article
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postArticle: async (article: Article, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'article' is not null or undefined
            assertParamExists('postArticle', 'article', article)
            const localVarPath = `/articles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(article, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification de la gamme de fonds
         * @param {GammeFonds} gammeFonds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGammeFonds: async (gammeFonds: GammeFonds, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gammeFonds' is not null or undefined
            assertParamExists('postGammeFonds', 'gammeFonds', gammeFonds)
            const localVarPath = `/gammeFonds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gammeFonds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Création d\'un lien de la gamme de fonds
         * @param {LienGammeFonds} lienGammeFonds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGammeFondsLien: async (lienGammeFonds: LienGammeFonds, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lienGammeFonds' is not null or undefined
            assertParamExists('postGammeFondsLien', 'lienGammeFonds', lienGammeFonds)
            const localVarPath = `/gammeFonds/lien`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lienGammeFonds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ajout d\'un bandeau d\'informations
         * @param {string} text 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInfoBanner: async (text: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'text' is not null or undefined
            assertParamExists('postInfoBanner', 'text', text)
            const localVarPath = `/infoBanners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(text, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enregistrement des données d\'un fichier source des commissions
         * @param {SourceCommissions} sourceCommissions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSourceCommissions: async (sourceCommissions: SourceCommissions, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceCommissions' is not null or undefined
            assertParamExists('postSourceCommissions', 'sourceCommissions', sourceCommissions)
            const localVarPath = `/source-commissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sourceCommissions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification d\'un article de news
         * @param {string} id 
         * @param {Article} article 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putArticle: async (id: string, article: Article, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putArticle', 'id', id)
            // verify required parameter 'article' is not null or undefined
            assertParamExists('putArticle', 'article', article)
            const localVarPath = `/articles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(article, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification d\'un lien de la gamme de fonds
         * @param {LienGammeFonds} lienGammeFonds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGammeFondsLien: async (lienGammeFonds: LienGammeFonds, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lienGammeFonds' is not null or undefined
            assertParamExists('putGammeFondsLien', 'lienGammeFonds', lienGammeFonds)
            const localVarPath = `/gammeFonds/lien`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lienGammeFonds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification d\'un bandeau d\'information
         * @param {string} id 
         * @param {InfoBanner} infoBanner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putInfoBanner: async (id: string, infoBanner: InfoBanner, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putInfoBanner', 'id', id)
            // verify required parameter 'infoBanner' is not null or undefined
            assertParamExists('putInfoBanner', 'infoBanner', infoBanner)
            const localVarPath = `/infoBanners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(infoBanner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Réception des données au parcours intermédiaire de la simulation d\'intéressement
         * @param {File} quickRecapPdf 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quickSimulationData: async (quickRecapPdf: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quickRecapPdf' is not null or undefined
            assertParamExists('quickSimulationData', 'quickRecapPdf', quickRecapPdf)
            const localVarPath = `/donnees/profit-sharing-generator/quick-simulation-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (quickRecapPdf !== undefined) { 
                localVarFormParams.append('quickRecapPdf', quickRecapPdf as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Régénération d\'un token JWT pour le tunel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rafraichirToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/donnees/rafraichirJwtToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recherche une entreprise dans la base SIRENE à partir du SIRET
         * @param {string} [siret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechercherEntreprise: async (siret?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/donnees/sirene/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (siret !== undefined) {
                localVarQueryParameter['siret'] = siret;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération de l\'URL DocuSign pour que l\'utilisateur puisse signer sa liasse de souscription
         * @param {string} uid 
         * @param {string} [redirectUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recupererUrlSignature: async (uid: string, redirectUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('recupererUrlSignature', 'uid', uid)
            const localVarPath = `/liassesSouscription/{uid}/url`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (redirectUrl !== undefined) {
                localVarQueryParameter['redirectUrl'] = redirectUrl;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Réception des données pour la sauvegarde d\'un tunnel personnalisé
         * @param {CustomTunnelData} customTunnelData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTunnel: async (customTunnelData: CustomTunnelData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customTunnelData' is not null or undefined
            assertParamExists('saveTunnel', 'customTunnelData', customTunnelData)
            const localVarPath = `/gerer-tunnels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customTunnelData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des informations du dossier de souscription à partir de l\'uid entreprise
         * @param {string} [uidEntreprise] id de l\&#39;entreprise du dossier
         * @param {string} [codeApporteur] le code apporteur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDossierSouscription: async (uidEntreprise?: string, codeApporteur?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dossiers/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (uidEntreprise !== undefined) {
                localVarQueryParameter['uidEntreprise'] = uidEntreprise;
            }

            if (codeApporteur !== undefined) {
                localVarQueryParameter['codeApporteur'] = codeApporteur;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Réception des données de la simulation d\'intéressement
         * @param {GeneratorData} generatorData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulationData: async (generatorData: GeneratorData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generatorData' is not null or undefined
            assertParamExists('simulationData', 'generatorData', generatorData)
            const localVarPath = `/donnees/profit-sharing-generator/simulation-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generatorData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permet de transmettre le dossier PEI PERcoi finalisé
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transmettreDossier: async (uid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('transmettreDossier', 'uid', uid)
            const localVarPath = `/dossiers/{uid}/transmettre`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification de l\'abondement PEE/PERCOI de l\'utilisateur
         * @param {string} uid 
         * @param {Dispositifs} dispositifs 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAbondements: async (uid: string, dispositifs: Dispositifs, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('updateAbondements', 'uid', uid)
            // verify required parameter 'dispositifs' is not null or undefined
            assertParamExists('updateAbondements', 'dispositifs', dispositifs)
            const localVarPath = `/dossiers/{uid}/abondements`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dispositifs, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ajout de l’Annexe KYC Amundi dans la liasse de documents pour signature électronique
         * @param {string} uid 
         * @param {DonneesKYC} donneesKYC 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnexeKYC: async (uid: string, donneesKYC: DonneesKYC, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('updateAnnexeKYC', 'uid', uid)
            // verify required parameter 'donneesKYC' is not null or undefined
            assertParamExists('updateAnnexeKYC', 'donneesKYC', donneesKYC)
            const localVarPath = `/dossiers/{uid}/donneesKYC`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(donneesKYC, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mise à jour d\'un apporteur de part son UUID
         * @param {string} uuid UUID Apporteur
         * @param {ApporteurWithFoldersId} [apporteurWithFoldersId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApporteur: async (uuid: string, apporteurWithFoldersId?: ApporteurWithFoldersId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateApporteur', 'uuid', uuid)
            const localVarPath = `/apporteurs/manage/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apporteurWithFoldersId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification du téléphone d\'un apporteur
         * @param {ApporteurTelephoneUpdate} [apporteurTelephoneUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApporteurTelephone: async (apporteurTelephoneUpdate?: ApporteurTelephoneUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/apporteurs/telephone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apporteurTelephoneUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification d\'un document de la bibliotheque
         * @param {string} idDocument 
         * @param {BibliothequeDocument} [bibliothequeDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBibliothequeDocument: async (idDocument: string, bibliothequeDocument?: BibliothequeDocument, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('updateBibliothequeDocument', 'idDocument', idDocument)
            const localVarPath = `/bibliotheque/document/{idDocument}`
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bibliothequeDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification d\'une section de la bibliotheque
         * @param {number} idSection 
         * @param {BibliothequeSection} bibliothequeSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBibliothequeSection: async (idSection: number, bibliothequeSection: BibliothequeSection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSection' is not null or undefined
            assertParamExists('updateBibliothequeSection', 'idSection', idSection)
            // verify required parameter 'bibliothequeSection' is not null or undefined
            assertParamExists('updateBibliothequeSection', 'bibliothequeSection', bibliothequeSection)
            const localVarPath = `/bibliotheque/section/{idSection}`
                .replace(`{${"idSection"}}`, encodeURIComponent(String(idSection)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bibliothequeSection, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modifiation des colleges et taux
         * @param {string} uid 
         * @param {CategoriesSalaries} categoriesSalaries 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoriesSalaries: async (uid: string, categoriesSalaries: CategoriesSalaries, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('updateCategoriesSalaries', 'uid', uid)
            // verify required parameter 'categoriesSalaries' is not null or undefined
            assertParamExists('updateCategoriesSalaries', 'categoriesSalaries', categoriesSalaries)
            const localVarPath = `/dossiers/{uid}/categoriesSalaries`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(categoriesSalaries, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification du commentaire lié à un dossier
         * @param {Commentaire} commentaire 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommentaireDossier: async (commentaire: Commentaire, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commentaire' is not null or undefined
            assertParamExists('updateCommentaireDossier', 'commentaire', commentaire)
            const localVarPath = `/donnees/commentaire-dossier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentaire, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Renseignement du RIB de l\'utilisateur
         * @param {string} uid 
         * @param {CompteDePrelevement} compteDePrelevement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompteDePrelevement: async (uid: string, compteDePrelevement: CompteDePrelevement, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('updateCompteDePrelevement', 'uid', uid)
            // verify required parameter 'compteDePrelevement' is not null or undefined
            assertParamExists('updateCompteDePrelevement', 'compteDePrelevement', compteDePrelevement)
            const localVarPath = `/dossiers/{uid}/compteDePrelevement`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(compteDePrelevement, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Depot de consentement d\'un salarié
         * @param {string} refInterne 
         * @param {string} idEmployee 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConsent: async (refInterne: string, idEmployee: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refInterne' is not null or undefined
            assertParamExists('updateConsent', 'refInterne', refInterne)
            // verify required parameter 'idEmployee' is not null or undefined
            assertParamExists('updateConsent', 'idEmployee', idEmployee)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('updateConsent', 'file', file)
            const localVarPath = `/consentements/file/{refInterne}/{idEmployee}`
                .replace(`{${"refInterne"}}`, encodeURIComponent(String(refInterne)))
                .replace(`{${"idEmployee"}}`, encodeURIComponent(String(idEmployee)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification des informations de l\'entreprise
         * @param {string} uid 
         * @param {Entreprise} entreprise 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntreprise: async (uid: string, entreprise: Entreprise, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('updateEntreprise', 'uid', uid)
            // verify required parameter 'entreprise' is not null or undefined
            assertParamExists('updateEntreprise', 'entreprise', entreprise)
            const localVarPath = `/entreprises/{uid}`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entreprise, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permet d\'ouvrir/fermer le flux HARVEST pour les distributeurs spécifiés
         * @param {boolean} toActivate ouverture/fermeture du flux
         * @param {Array<string>} [requestBody] liste des apporteurs uuids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFluxHarvest: async (toActivate: boolean, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toActivate' is not null or undefined
            assertParamExists('updateFluxHarvest', 'toActivate', toActivate)
            const localVarPath = `/apporteurs/flux-harvest/{toActivate}`
                .replace(`{${"toActivate"}}`, encodeURIComponent(String(toActivate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification de la fonction du dirigeant dans l\'entreprise
         * @param {string} uid 
         * @param {Fonction} fonction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFonctionDansEntreprise: async (uid: string, fonction: Fonction, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('updateFonctionDansEntreprise', 'uid', uid)
            // verify required parameter 'fonction' is not null or undefined
            assertParamExists('updateFonctionDansEntreprise', 'fonction', fonction)
            const localVarPath = `/utilisateurs/{uid}/fonctionDansEntreprise`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fonction, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modifiation des frais de contrat dans le dossier
         * @param {string} uid 
         * @param {FraisContrat} fraisContrat 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFraisContrat: async (uid: string, fraisContrat: FraisContrat, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('updateFraisContrat', 'uid', uid)
            // verify required parameter 'fraisContrat' is not null or undefined
            assertParamExists('updateFraisContrat', 'fraisContrat', fraisContrat)
            const localVarPath = `/dossiers/{uid}/fraisContrat`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fraisContrat, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modifiation choix de garantie de prevoyance au dossier
         * @param {string} uid 
         * @param {GarantiesPrevoyance} garantiesPrevoyance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGarantiesPrevoyance: async (uid: string, garantiesPrevoyance: GarantiesPrevoyance, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('updateGarantiesPrevoyance', 'uid', uid)
            // verify required parameter 'garantiesPrevoyance' is not null or undefined
            assertParamExists('updateGarantiesPrevoyance', 'garantiesPrevoyance', garantiesPrevoyance)
            const localVarPath = `/dossiers/{uid}/garantiesPrevoyance`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(garantiesPrevoyance, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification des informations de l\'utilisateur
         * @param {string} uid 
         * @param {Dirigeant} dirigeant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformationsUtilisateur: async (uid: string, dirigeant: Dirigeant, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('updateInformationsUtilisateur', 'uid', uid)
            // verify required parameter 'dirigeant' is not null or undefined
            assertParamExists('updateInformationsUtilisateur', 'dirigeant', dirigeant)
            const localVarPath = `/utilisateurs/{uid}`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dirigeant, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mettre en place de l\'intérèssement ou non
         * @param {string} uid 
         * @param {Interessement} interessement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInteressement: async (uid: string, interessement: Interessement, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('updateInteressement', 'uid', uid)
            // verify required parameter 'interessement' is not null or undefined
            assertParamExists('updateInteressement', 'interessement', interessement)
            const localVarPath = `/dossiers/{uid}/interessement`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(interessement, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mise en place de la participation ou non en cas d\'entreprise de plus de 50 salariés
         * @param {string} uid 
         * @param {Participation} participation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParticipation: async (uid: string, participation: Participation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('updateParticipation', 'uid', uid)
            // verify required parameter 'participation' is not null or undefined
            assertParamExists('updateParticipation', 'participation', participation)
            const localVarPath = `/dossiers/{uid}/participation`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(participation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mise à jour des valeurs du PASS
         * @param {Pass} pass 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePass: async (pass: Pass, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pass' is not null or undefined
            assertParamExists('updatePass', 'pass', pass)
            const localVarPath = `/donnees/pass`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pass, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Informations à renseigner en cas de transfert d\'un PEE / PERCO
         * @param {string} uid 
         * @param {PlanExistant} planExistant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanExistant: async (uid: string, planExistant: PlanExistant, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('updatePlanExistant', 'uid', uid)
            // verify required parameter 'planExistant' is not null or undefined
            assertParamExists('updatePlanExistant', 'planExistant', planExistant)
            const localVarPath = `/dossiers/{uid}/planExistant`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(planExistant, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification des positions des sections de la bibliotheque
         * @param {Array<BibliothequeSection>} bibliothequeSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePositionSections: async (bibliothequeSection: Array<BibliothequeSection>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bibliothequeSection' is not null or undefined
            assertParamExists('updatePositionSections', 'bibliothequeSection', bibliothequeSection)
            const localVarPath = `/bibliotheque/sections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bibliothequeSection, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mise à jour booléen activation du service
         * @param {ServiceActivation} serviceActivation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateService: async (serviceActivation: ServiceActivation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceActivation' is not null or undefined
            assertParamExists('updateService', 'serviceActivation', serviceActivation)
            const localVarPath = `/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serviceActivation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Changement de l\'étape
         * @param {string} uid 
         * @param {EtapeDossier} [etapeDossier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStep: async (uid: string, etapeDossier?: EtapeDossier, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('updateStep', 'uid', uid)
            const localVarPath = `/dossiers/{uid}/etape`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(etapeDossier, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mise à jour des informations de tarification
         * @param {string} uid 
         * @param {Tarification} tarification 
         * @param {boolean} [sauvegardeSeule] Si true, sauvegarde la tarification sans changer l\&#39;étape du dossier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTarification: async (uid: string, tarification: Tarification, sauvegardeSeule?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('updateTarification', 'uid', uid)
            // verify required parameter 'tarification' is not null or undefined
            assertParamExists('updateTarification', 'tarification', tarification)
            const localVarPath = `/dossiers/{uid}/tarification`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (sauvegardeSeule !== undefined) {
                localVarQueryParameter['sauvegardeSeule'] = sauvegardeSeule;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tarification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload des fichiers utilisé pour un tunnel personnalisé d\'un réseau
         * @param {string} reseau 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomTunnelFiles: async (reseau: string, files?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reseau' is not null or undefined
            assertParamExists('uploadCustomTunnelFiles', 'reseau', reseau)
            const localVarPath = `/gerer-tunnels/{reseau}/files`
                .replace(`{${"reseau"}}`, encodeURIComponent(String(reseau)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload du justificatif \'Carte professionnelle\' (profession libérale)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageCarteProfessionnelle: async (uid: string, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('uploadPageCarteProfessionnelle', 'uid', uid)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadPageCarteProfessionnelle', 'files', files)
            const localVarPath = `/entreprises/{uid}/justificatifCarteProfessionnelle`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload du justificatif \'Copie du décret de reconnaissance de l’utilité publique\' (association)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageDecretReco: async (uid: string, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('uploadPageDecretReco', 'uid', uid)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadPageDecretReco', 'files', files)
            const localVarPath = `/entreprises/{uid}/justificatifDecretReco`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload de la copie du pouvoir donné pour engager l\'entreprise en matière d\'épargne salariale si le nom du signataire n’apparaît pas sur l\'extrait K-Bis ou l\'extrait du registre des métiers
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageDelegationPouvoir: async (uid: string, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('uploadPageDelegationPouvoir', 'uid', uid)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadPageDelegationPouvoir', 'files', files)
            const localVarPath = `/entreprises/{uid}/delegationPouvoir`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload d\'un justificatif d\'identité
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageJustificatifIdentite: async (uid: string, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('uploadPageJustificatifIdentite', 'uid', uid)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadPageJustificatifIdentite', 'files', files)
            const localVarPath = `/utilisateurs/{uid}/justificatifIdentite`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload du justificatif d\'identité de l\'entreprise (KBIS ou justificatif d\'inscription à l\'ordre des métiers)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageJustificatifIdentiteEntreprise: async (uid: string, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('uploadPageJustificatifIdentiteEntreprise', 'uid', uid)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadPageJustificatifIdentiteEntreprise', 'files', files)
            const localVarPath = `/entreprises/{uid}/justificatifIdentiteEntreprise`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload d\'un côté d\'un justificatif d\'identité
         * @param {string} uid 
         * @param {boolean} isRecto 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageJustificatifIdentite_2: async (uid: string, isRecto: boolean, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('uploadPageJustificatifIdentite_2', 'uid', uid)
            // verify required parameter 'isRecto' is not null or undefined
            assertParamExists('uploadPageJustificatifIdentite_2', 'isRecto', isRecto)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadPageJustificatifIdentite_2', 'files', files)
            const localVarPath = `/utilisateurs/{uid}/justificatifIdentite/{isRecto}/`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)))
                .replace(`{${"isRecto"}}`, encodeURIComponent(String(isRecto)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload d\'un justificatif d\'identité (passeport)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPagePasseport: async (uid: string, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('uploadPagePasseport', 'uid', uid)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadPagePasseport', 'files', files)
            const localVarPath = `/utilisateurs/{uid}/passeport`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload du justificatif \'Récépissé de déclaration en préfecture\' (association)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageRecepDeclaPref: async (uid: string, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('uploadPageRecepDeclaPref', 'uid', uid)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadPageRecepDeclaPref', 'files', files)
            const localVarPath = `/entreprises/{uid}/justificatifRecepDeclaPref`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload du justificatif \'Récépissé d’insertion légale au Journal Officiel\' (association)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageRecepInsertion: async (uid: string, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('uploadPageRecepInsertion', 'uid', uid)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadPageRecepInsertion', 'files', files)
            const localVarPath = `/entreprises/{uid}/justificatifRecepInsertion`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload des statuts de l\'entreprise
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageStatuts: async (uid: string, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('uploadPageStatuts', 'uid', uid)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadPageStatuts', 'files', files)
            const localVarPath = `/entreprises/{uid}/statuts`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary validation ou rejet d\'un consentement d\'un ou plusieurs salariés
         * @param {string} refInterne 
         * @param {string} idEmployee 
         * @param {boolean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validationConsent: async (refInterne: string, idEmployee: string, body: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refInterne' is not null or undefined
            assertParamExists('validationConsent', 'refInterne', refInterne)
            // verify required parameter 'idEmployee' is not null or undefined
            assertParamExists('validationConsent', 'idEmployee', idEmployee)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('validationConsent', 'body', body)
            const localVarPath = `/consentements/file/{refInterne}/{idEmployee}`
                .replace(`{${"refInterne"}}`, encodeURIComponent(String(refInterne)))
                .replace(`{${"idEmployee"}}`, encodeURIComponent(String(idEmployee)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary active specified folders
         * @param {FolderUids} folderUids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activeFolders(folderUids: FolderUids, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Dossier>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activeFolders(folderUids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.activeFolders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ajout d\'un commentaire sur un dossier
         * @param {Commentaire} commentaire 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCommentaireDossier(commentaire: Commentaire, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Commentaire>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCommentaireDossier(commentaire, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addCommentaireDossier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Annulation d\'une liasse de souscription
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async annulerLiasse(uid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.annulerLiasse(uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.annulerLiasse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archive specified folders
         * @param {FolderUids} folderUids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveFolders(folderUids: FolderUids, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Dossier>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveFolders(folderUids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.archiveFolders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verification de cookie valide sinon retour des cgu en html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkCgu(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkCgu(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.checkCgu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Connexion à une session avec le token sso
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connecterSSO(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connecterSSO(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.connecterSSO']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Envoi des données du formulaire de contact
         * @param {ContactData} contactData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactData(contactData: ContactData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactData(contactData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.contactData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Création d\'un nouveau apporteur
         * @param {ApporteurLight} [apporteurLight] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createApporteur(apporteurLight?: ApporteurLight, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createApporteur(apporteurLight, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createApporteur']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary création d\'un document de la section de la bibliotheque
         * @param {string} idSection 
         * @param {BibliothequeDocument} [bibliothequeDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBibliothequeDocument(idSection: string, bibliothequeDocument?: BibliothequeDocument, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BibliothequeDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBibliothequeDocument(idSection, bibliothequeDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createBibliothequeDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ajout d\'une section de la bibliotheque
         * @param {BibliothequeSection} bibliothequeSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBibliothequeSection(bibliothequeSection: BibliothequeSection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BibliothequeSection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBibliothequeSection(bibliothequeSection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createBibliothequeSection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Création d\'un nouveau groupe (réseau apporteur)
         * @param {Groupe} groupe 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGroupe(groupe: Groupe, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Groupe>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGroupe(groupe, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createGroupe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Création d\'un nouvel inspecteur
         * @param {Inspecteur} inspecteur 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInspecteur(inspecteur: Inspecteur, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Inspecteur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInspecteur(inspecteur, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createInspecteur']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Création de la liasse de souscription
         * @param {DossierUid} dossierUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creerLiasseSouscription(dossierUid: DossierUid, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiasseSouscription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creerLiasseSouscription(dossierUid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.creerLiasseSouscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression d\'une liste d\'apporteurs
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteApporteurs(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApporteurs(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteApporteurs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modification d\'un article de news
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteArticle(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteArticle(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteArticle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary suppression d\'un document de la bibliotheque
         * @param {string} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBibliothequeDocument(idDocument: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBibliothequeDocument(idDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteBibliothequeDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary suppression d\'une section de la bibliotheque
         * @param {number} idSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBibliothequeSection(idSection: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBibliothequeSection(idSection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteBibliothequeSection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression d\'un commentaire sur un dossier
         * @param {string} dossierUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCommentaireDossier(dossierUid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCommentaireDossier(dossierUid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteCommentaireDossier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression du fichier de consentement pour l\'utilisateur
         * @param {string} refInterne 
         * @param {string} idEmployee 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConsent(refInterne: string, idEmployee: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionConsents>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConsent(refInterne, idEmployee, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary suppression du fichier d\'un document de la bibliotheque
         * @param {string} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentFile(idDocument: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumentFile(idDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteDocumentFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression d\'un lien de la gamme de fonds
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGammeFondsLien(linkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGammeFondsLien(linkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteGammeFondsLien']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression d\'un bandeau d\'informations
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInfoBanner(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InfoBanner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInfoBanner(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteInfoBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression du justificatif \'Carte professionnelle\' (profession libérale)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePageCarteProfessionnelle(uid: string, nom?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePageCarteProfessionnelle(uid, nom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePageCarteProfessionnelle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression du justificatif \'Copie du décret de reconnaissance de l’utilité publique\' (association)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePageDecretReco(uid: string, nom?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePageDecretReco(uid, nom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePageDecretReco']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression du Delegation du pouvoir
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePageDelegationPouvoir(uid: string, nom?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePageDelegationPouvoir(uid, nom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePageDelegationPouvoir']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression d\'une page d\'une pièce justificative de dossier de souscription
         * @param {string} uid UID du dossier de souscription
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePageDocument(uid: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePageDocument(uid, fileMetadata, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePageDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression d\'un justificatif d\'identité
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePageJustificatifIdentite(uid: string, nom?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Utilisateur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePageJustificatifIdentite(uid, nom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePageJustificatifIdentite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression d\'une page du justificatif de l\'entreprise
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePageJustificatifIdentiteEntreprise(uid: string, nom?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePageJustificatifIdentiteEntreprise(uid, nom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePageJustificatifIdentiteEntreprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression d\'un côté d\'un justificatif d\'identité
         * @param {string} uid 
         * @param {boolean} isRecto 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePageJustificatifIdentite_1(uid: string, isRecto: boolean, nom?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Utilisateur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePageJustificatifIdentite_1(uid, isRecto, nom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePageJustificatifIdentite_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression d\'un justificatif d\'identité (passeport)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePagePasseport(uid: string, nom?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Utilisateur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePagePasseport(uid, nom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePagePasseport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression du justificatif \'Récépissé de déclaration en préfecture\' (association)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePageRecepDeclaPref(uid: string, nom?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePageRecepDeclaPref(uid, nom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePageRecepDeclaPref']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression du justificatif \'Récépissé d’insertion légale au Journal Officiel\' (association)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePageRecepInsertion(uid: string, nom?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePageRecepInsertion(uid, nom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePageRecepInsertion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression d\'une page des statuts de l\'entreprise
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePageStatuts(uid: string, nom?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePageStatuts(uid, nom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePageStatuts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suppression des données d\'un fichier source des commissions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSourceCommissions(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSourceCommissions(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteSourceCommissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Création d\'une entreprise et initialisation d\'un dossier
         * @param {Entreprise} entreprise 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enregistrerEntreprise(entreprise: Entreprise, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AjoutEntreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enregistrerEntreprise(entreprise, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.enregistrerEntreprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permet de transmettre le bulletin d\'adhésion au client par mail
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async envoiMailAvantSignature(uid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.envoiMailAvantSignature(uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.envoiMailAvantSignature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Génération d\'un token SSO pour le portail GES
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genererTokenSso(uid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenSso>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.genererTokenSso(uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.genererTokenSso']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all active subscription folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllActiveFolders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DossierRecap>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllActiveFolders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllActiveFolders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération de toutes les activités présentes en base de données
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllActivities(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Activity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllActivities(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des apporteurs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllApporteurs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Apporteur>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllApporteurs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllApporteurs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all archived subscription folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllArchivedFolders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DossierRecap>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllArchivedFolders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllArchivedFolders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération de tous les consentements contenant à minima un fichier de consentement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllConsents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubscriptionConsents>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllConsents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllConsents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des consentements de l\'apporteur d\'affaire (du token ou spécifié)
         * @param {string} [codeApporteur] Code de l\&#39;apporteur d\&#39;affaire. Si non fourni, utilise le code du bearer token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllConsentsByBusinessProvider(codeApporteur?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubscriptionConsents>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllConsentsByBusinessProvider(codeApporteur, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllConsentsByBusinessProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des groupes (= réseaux apporteurs)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllGroupes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Groupe>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllGroupes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllGroupes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des inspecteurs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllInspecteurs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Inspecteur>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllInspecteurs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllInspecteurs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Role>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des sections de la bibliothèque ainsi que des documents associés
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSections(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BibliothequeSection>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSections(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllSections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * L\'user_id auth0 de l\'apporteur à récupérer est stocké dans le Bearer token, dans la propriété sub
         * @summary Récupération des données d\'un apporteur pour l\'authentification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApporteurByAuthId(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Apporteur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApporteurByAuthId(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getApporteurByAuthId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération d\'un document d\'actualité du portail
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleDocument(filename: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArticleDocument(filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getArticleDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des articles des news
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Article>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArticles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getArticles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération d\'une section de la bibliotheque
         * @param {number} idSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBibliothequeSection(idSection: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BibliothequeSection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBibliothequeSection(idSection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBibliothequeSection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération du commentaire lié à un dossier
         * @param {string} dossierUid La référence du dossier pour lequel on veut le commentaire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommentaireDossier(dossierUid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Commentaire>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommentaireDossier(dossierUid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommentaireDossier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des commissions liées à un trimestre et un code apporteur
         * @param {string} annee 
         * @param {string} trimestre 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommissionByQuarter(annee: string, trimestre: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Commission>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommissionByQuarter(annee, trimestre, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommissionByQuarter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération de la liste des commissions d\'un apporteur sous forme de tableau Excel
         * @param {string} annee 
         * @param {string} trimestre 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommissionsFile(annee: string, trimestre: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommissionsFile(annee, trimestre, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommissionsFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des informations d\'une entreprise depuis son SIRET
         * @param {string} siret Le numéro SIRET de l\&#39;entreprise
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyInfo(siret: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyInfo(siret, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCompanyInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération d\'un dossier de consentement par sa référence Interne
         * @param {string} refInterne 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsentByRefInterne(refInterne: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionConsents>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConsentByRefInterne(refInterne, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getConsentByRefInterne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération du document de consentement d\'un des salariés pour la visualisation du back office
         * @param {string} refInterne 
         * @param {string} idEmployee 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsentFileToPreview(refInterne: string, idEmployee: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConsentFileToPreview(refInterne, idEmployee, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getConsentFileToPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération du document pdf du modèle pour le consentement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsentModel(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConsentModel(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getConsentModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération de la liste des pays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Pays>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des critères de financiers, qualitatifs et RSE associés à un id de secteur d\'activité
         * @param {number} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCriteria(activityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanySector>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCriteria(activityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération de la liste des tunnels personnalisés
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomTunnels(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomTunnelData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomTunnels(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCustomTunnels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération d\'un fichier à un document de la bibliothèque
         * @param {string} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentFile(idDocument: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentFile(idDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getDocumentFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération du dossier de souscription
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDossier(uid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dossier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDossier(uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getDossier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des documents contractuels d\'un dossier
         * @param {string} dossierUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDossierContractDocuments(dossierUid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDossierContractDocuments(dossierUid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getDossierContractDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération du dossier de souscription complet
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDossierDetails(uid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierAvecEntreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDossierDetails(uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getDossierDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des informations de l\'entreprise
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntreprise(uid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntreprise(uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getEntreprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des évènements du domaine Plan Epargne Salarial selon différents critères
         * @param {string} [dateDebut] Recherche des évènements à partir de cette date / Format -&gt; jj/MM/YYYY
         * @param {string} [dateFin] Recherche des évènements jusqu\&#39;à cette date / Format -&gt; jj/MM/YYYY
         * @param {string} [entityName] Nom de l\&#39;entité concerné par l\&#39;évènement.
         * @param {string} [entityUid] uid de l\&#39;entité concernée par l\&#39;évènement. Il se trouve dans les metadatas
         * @param {string} [eventType] Nom de l\&#39;évènement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventsPlan(dateDebut?: string, dateFin?: string, entityName?: string, entityUid?: string, eventType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventsPlan(dateDebut, dateFin, entityName, entityUid, eventType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getEventsPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des évènements du domaine Référentiel Organisationnel selon différents critères
         * @param {string} [dateDebut] Recherche des évènements à partir de cette date / Format -&gt; jj/MM/YYYY
         * @param {string} [dateFin] Recherche des évènements jusqu\&#39;à cette date / Format -&gt; jj/MM/YYYY
         * @param {string} [entityName] Nom de l\&#39;entité concerné par l\&#39;évènement.
         * @param {string} [entityUid] uid de l\&#39;entité concernée par l\&#39;évènement. Il se trouve dans les metadatas
         * @param {string} [eventType] Nom de l\&#39;évènement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventsReferentielOrga(dateDebut?: string, dateFin?: string, entityName?: string, entityUid?: string, eventType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventsReferentielOrga(dateDebut, dateFin, entityName, entityUid, eventType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getEventsReferentielOrga']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération d\'un fichier du dossier custom_tunnels du S3
         * @param {string} reseau 
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFile(reseau: string, filename: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFile(reseau, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération de données de la rubrique \'Formations\' du portail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Formations>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFormations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFormations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération d\'un URL vers le S3 pour la vidéo
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormationsUrl(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFormationsUrl(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFormationsUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des liens de la gamme de fonds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGammeFonds(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GammeFonds>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGammeFonds(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getGammeFonds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Envoie des données de la simulation d\'intéressement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneratorDatas(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneratorData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneratorDatas(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getGeneratorDatas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des bandeaux d\'informations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInfoBanners(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListInfoBanners>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInfoBanners(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getInfoBanners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération valeurs du PASS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPASS(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pass>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPASS(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPASS']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération du document pdf pour les Performances cumulées
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPerformancesCumulees(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPerformancesCumulees(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPerformancesCumulees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Requête une URL signée d\'upload AWS pour l\'ajout d\'un fichier de source commissions
         * @param {string} id 
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresignedUploadURLForCommissionsFile(id: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresignedUploadURLForCommissionsFile(id, fileMetadata, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPresignedUploadURLForCommissionsFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Requête une URL signée d\'upload AWS pour l\'ajout d\'un fichier dans la bibliothèque
         * @param {string} idDocument 
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresignedUploadURLForLibraryDocumentFile(idDocument: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresignedUploadURLForLibraryDocumentFile(idDocument, fileMetadata, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPresignedUploadURLForLibraryDocumentFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Requête une URL signée d\'upload AWS pour une page de pièce justificative de dossier de souscription
         * @param {string} uid UID du dossier de souscription
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresignedUploadURLForPageDocument(uid: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresignedUploadURLForPageDocument(uid, fileMetadata, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPresignedUploadURLForPageDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération d\'une URL présignée pour déposer le document des Performances cumulées
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresignedUploadURLForPerformancesCumulees(fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresignedUploadURLForPerformancesCumulees(fileMetadata, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPresignedUploadURLForPerformancesCumulees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Génère un fichier excel avec le rapport de dossies de souscription du tunnel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRapports(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRapports(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRapports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération de la liste des récaps des commissions d\'un apporteur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecapCommissionsApporteur(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RecapCommission>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecapCommissionsApporteur(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRecapCommissionsApporteur']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération activation du service avec son nom
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceByName(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceActivation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceByName(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getServiceByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération activation des services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceActivation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des données simplifiées des dossiers de souscription actifs pour un apporteur
         * @param {string} [codeApporteur] Code de l\&#39;apporteur pour filtrer les dossiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimpleActiveFolders(codeApporteur?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DossierAvecEntrepriseRecap>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimpleActiveFolders(codeApporteur, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSimpleActiveFolders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération du document zip pour le Simulateur CAMPAGNE+ de suivi d\'activité
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulateurCampagnePlus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulateurCampagnePlus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSimulateurCampagnePlus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récuperation d\'une URL présignée d\'un fichier de source commissions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSourceCommissionsFile(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSourceCommissionsFile(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSourceCommissionsFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération de la liste des fichiers sources de commissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSourcesCommissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceCommissions>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSourcesCommissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSourcesCommissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération de la page de template de test interprété par Thymeleaf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateMail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération du fichier excel avec le transfers plan épargne salariale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransferts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransferts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTransferts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des informations de l\'utilisateur
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUtilisateur(uid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Utilisateur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUtilisateur(uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUtilisateur']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Initialise un dossier de souscription avec les données d\'un apporteur d\'affaire
         * @param {InitDossier} [initDossier] Dossier avec apporteur d\&#39;affaire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initDossier(initDossier?: InitDossier, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dossier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initDossier(initDossier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.initDossier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Webhook utilisé par Docusign pour récupérer la liasse signée
         * @param {string} tenant 
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifierLiasse(tenant: string, uid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifierLiasse(tenant, uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.notifierLiasse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enregistre en BD l\'ajout du fichier de la bibliothèque. Route appelée après qu\'un upload AWS ait réussi côté client.
         * @summary Enregistre l\'ajout d\'un fichier de la bibliothèque
         * @param {string} idDocument 
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyLibraryDocumentFileUploaded(idDocument: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BibliothequeDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyLibraryDocumentFileUploaded(idDocument, fileMetadata, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.notifyLibraryDocumentFileUploaded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enregistre en BD l\'ajout de la page de la pièce justificative pour un dossier de souscription. Route appelée après qu\'un upload AWS ait réussi côté client.
         * @summary Enregistre l\'ajout de la page de la pièce justificative pour un dossier de souscription
         * @param {string} uid UID du dossier de souscription
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyPageDocumentUploaded(uid: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyPageDocumentUploaded(uid, fileMetadata, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.notifyPageDocumentUploaded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Notifie le serveur après la réussite de l\'upload du document vers AWS S3.
         * @summary Enregistrement du document des Performances cumulées après son dépôt
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyPerformancesCumuleesUploaded(fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyPerformancesCumuleesUploaded(fileMetadata, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.notifyPerformancesCumuleesUploaded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ajout d\'un article de news
         * @param {Article} article Article
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postArticle(article: Article, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Article>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postArticle(article, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.postArticle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modification de la gamme de fonds
         * @param {GammeFonds} gammeFonds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postGammeFonds(gammeFonds: GammeFonds, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GammeFonds>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postGammeFonds(gammeFonds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.postGammeFonds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Création d\'un lien de la gamme de fonds
         * @param {LienGammeFonds} lienGammeFonds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postGammeFondsLien(lienGammeFonds: LienGammeFonds, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LienGammeFonds>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postGammeFondsLien(lienGammeFonds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.postGammeFondsLien']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ajout d\'un bandeau d\'informations
         * @param {string} text 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postInfoBanner(text: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InfoBanner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postInfoBanner(text, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.postInfoBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Enregistrement des données d\'un fichier source des commissions
         * @param {SourceCommissions} sourceCommissions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSourceCommissions(sourceCommissions: SourceCommissions, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceCommissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSourceCommissions(sourceCommissions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.postSourceCommissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modification d\'un article de news
         * @param {string} id 
         * @param {Article} article 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putArticle(id: string, article: Article, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putArticle(id, article, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.putArticle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modification d\'un lien de la gamme de fonds
         * @param {LienGammeFonds} lienGammeFonds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putGammeFondsLien(lienGammeFonds: LienGammeFonds, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LienGammeFonds>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putGammeFondsLien(lienGammeFonds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.putGammeFondsLien']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modification d\'un bandeau d\'information
         * @param {string} id 
         * @param {InfoBanner} infoBanner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putInfoBanner(id: string, infoBanner: InfoBanner, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InfoBanner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putInfoBanner(id, infoBanner, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.putInfoBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Réception des données au parcours intermédiaire de la simulation d\'intéressement
         * @param {File} quickRecapPdf 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quickSimulationData(quickRecapPdf: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quickSimulationData(quickRecapPdf, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.quickSimulationData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Régénération d\'un token JWT pour le tunel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rafraichirToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rafraichirToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rafraichirToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Recherche une entreprise dans la base SIRENE à partir du SIRET
         * @param {string} [siret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rechercherEntreprise(siret?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SireneInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rechercherEntreprise(siret, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rechercherEntreprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération de l\'URL DocuSign pour que l\'utilisateur puisse signer sa liasse de souscription
         * @param {string} uid 
         * @param {string} [redirectUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recupererUrlSignature(uid: string, redirectUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UrlSignature>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recupererUrlSignature(uid, redirectUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.recupererUrlSignature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Réception des données pour la sauvegarde d\'un tunnel personnalisé
         * @param {CustomTunnelData} customTunnelData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTunnel(customTunnelData: CustomTunnelData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTunnel(customTunnelData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveTunnel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupération des informations du dossier de souscription à partir de l\'uid entreprise
         * @param {string} [uidEntreprise] id de l\&#39;entreprise du dossier
         * @param {string} [codeApporteur] le code apporteur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDossierSouscription(uidEntreprise?: string, codeApporteur?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DossierAvecEntreprise>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDossierSouscription(uidEntreprise, codeApporteur, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchDossierSouscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Réception des données de la simulation d\'intéressement
         * @param {GeneratorData} generatorData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simulationData(generatorData: GeneratorData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simulationData(generatorData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.simulationData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permet de transmettre le dossier PEI PERcoi finalisé
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transmettreDossier(uid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dossier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transmettreDossier(uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.transmettreDossier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modification de l\'abondement PEE/PERCOI de l\'utilisateur
         * @param {string} uid 
         * @param {Dispositifs} dispositifs 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAbondements(uid: string, dispositifs: Dispositifs, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dossier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAbondements(uid, dispositifs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateAbondements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ajout de l’Annexe KYC Amundi dans la liasse de documents pour signature électronique
         * @param {string} uid 
         * @param {DonneesKYC} donneesKYC 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAnnexeKYC(uid: string, donneesKYC: DonneesKYC, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dossier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAnnexeKYC(uid, donneesKYC, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateAnnexeKYC']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mise à jour d\'un apporteur de part son UUID
         * @param {string} uuid UUID Apporteur
         * @param {ApporteurWithFoldersId} [apporteurWithFoldersId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateApporteur(uuid: string, apporteurWithFoldersId?: ApporteurWithFoldersId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Apporteur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateApporteur(uuid, apporteurWithFoldersId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateApporteur']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modification du téléphone d\'un apporteur
         * @param {ApporteurTelephoneUpdate} [apporteurTelephoneUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateApporteurTelephone(apporteurTelephoneUpdate?: ApporteurTelephoneUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateApporteurTelephone(apporteurTelephoneUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateApporteurTelephone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modification d\'un document de la bibliotheque
         * @param {string} idDocument 
         * @param {BibliothequeDocument} [bibliothequeDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBibliothequeDocument(idDocument: string, bibliothequeDocument?: BibliothequeDocument, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BibliothequeDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBibliothequeDocument(idDocument, bibliothequeDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateBibliothequeDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modification d\'une section de la bibliotheque
         * @param {number} idSection 
         * @param {BibliothequeSection} bibliothequeSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBibliothequeSection(idSection: number, bibliothequeSection: BibliothequeSection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BibliothequeSection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBibliothequeSection(idSection, bibliothequeSection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateBibliothequeSection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modifiation des colleges et taux
         * @param {string} uid 
         * @param {CategoriesSalaries} categoriesSalaries 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCategoriesSalaries(uid: string, categoriesSalaries: CategoriesSalaries, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoriesSalaries>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCategoriesSalaries(uid, categoriesSalaries, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateCategoriesSalaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modification du commentaire lié à un dossier
         * @param {Commentaire} commentaire 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommentaireDossier(commentaire: Commentaire, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommentaireDossier(commentaire, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateCommentaireDossier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Renseignement du RIB de l\'utilisateur
         * @param {string} uid 
         * @param {CompteDePrelevement} compteDePrelevement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompteDePrelevement(uid: string, compteDePrelevement: CompteDePrelevement, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dossier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompteDePrelevement(uid, compteDePrelevement, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateCompteDePrelevement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Depot de consentement d\'un salarié
         * @param {string} refInterne 
         * @param {string} idEmployee 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConsent(refInterne: string, idEmployee: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionConsents>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConsent(refInterne, idEmployee, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modification des informations de l\'entreprise
         * @param {string} uid 
         * @param {Entreprise} entreprise 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntreprise(uid: string, entreprise: Entreprise, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntreprise(uid, entreprise, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateEntreprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permet d\'ouvrir/fermer le flux HARVEST pour les distributeurs spécifiés
         * @param {boolean} toActivate ouverture/fermeture du flux
         * @param {Array<string>} [requestBody] liste des apporteurs uuids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFluxHarvest(toActivate: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFluxHarvest(toActivate, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateFluxHarvest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modification de la fonction du dirigeant dans l\'entreprise
         * @param {string} uid 
         * @param {Fonction} fonction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFonctionDansEntreprise(uid: string, fonction: Fonction, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Utilisateur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFonctionDansEntreprise(uid, fonction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateFonctionDansEntreprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modifiation des frais de contrat dans le dossier
         * @param {string} uid 
         * @param {FraisContrat} fraisContrat 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFraisContrat(uid: string, fraisContrat: FraisContrat, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FraisContrat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFraisContrat(uid, fraisContrat, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateFraisContrat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modifiation choix de garantie de prevoyance au dossier
         * @param {string} uid 
         * @param {GarantiesPrevoyance} garantiesPrevoyance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGarantiesPrevoyance(uid: string, garantiesPrevoyance: GarantiesPrevoyance, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GarantiesPrevoyance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGarantiesPrevoyance(uid, garantiesPrevoyance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateGarantiesPrevoyance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modification des informations de l\'utilisateur
         * @param {string} uid 
         * @param {Dirigeant} dirigeant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInformationsUtilisateur(uid: string, dirigeant: Dirigeant, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Utilisateur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInformationsUtilisateur(uid, dirigeant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateInformationsUtilisateur']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mettre en place de l\'intérèssement ou non
         * @param {string} uid 
         * @param {Interessement} interessement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInteressement(uid: string, interessement: Interessement, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dossier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInteressement(uid, interessement, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateInteressement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mise en place de la participation ou non en cas d\'entreprise de plus de 50 salariés
         * @param {string} uid 
         * @param {Participation} participation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateParticipation(uid: string, participation: Participation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dossier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateParticipation(uid, participation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateParticipation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mise à jour des valeurs du PASS
         * @param {Pass} pass 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePass(pass: Pass, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pass>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePass(pass, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updatePass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Informations à renseigner en cas de transfert d\'un PEE / PERCO
         * @param {string} uid 
         * @param {PlanExistant} planExistant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlanExistant(uid: string, planExistant: PlanExistant, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dossier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlanExistant(uid, planExistant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updatePlanExistant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modification des positions des sections de la bibliotheque
         * @param {Array<BibliothequeSection>} bibliothequeSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePositionSections(bibliothequeSection: Array<BibliothequeSection>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BibliothequeSection>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePositionSections(bibliothequeSection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updatePositionSections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mise à jour booléen activation du service
         * @param {ServiceActivation} serviceActivation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateService(serviceActivation: ServiceActivation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceActivation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateService(serviceActivation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Changement de l\'étape
         * @param {string} uid 
         * @param {EtapeDossier} [etapeDossier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStep(uid: string, etapeDossier?: EtapeDossier, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dossier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStep(uid, etapeDossier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mise à jour des informations de tarification
         * @param {string} uid 
         * @param {Tarification} tarification 
         * @param {boolean} [sauvegardeSeule] Si true, sauvegarde la tarification sans changer l\&#39;étape du dossier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTarification(uid: string, tarification: Tarification, sauvegardeSeule?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dossier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTarification(uid, tarification, sauvegardeSeule, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateTarification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload des fichiers utilisé pour un tunnel personnalisé d\'un réseau
         * @param {string} reseau 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCustomTunnelFiles(reseau: string, files?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCustomTunnelFiles(reseau, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadCustomTunnelFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload du justificatif \'Carte professionnelle\' (profession libérale)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPageCarteProfessionnelle(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPageCarteProfessionnelle(uid, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadPageCarteProfessionnelle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload du justificatif \'Copie du décret de reconnaissance de l’utilité publique\' (association)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPageDecretReco(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPageDecretReco(uid, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadPageDecretReco']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload de la copie du pouvoir donné pour engager l\'entreprise en matière d\'épargne salariale si le nom du signataire n’apparaît pas sur l\'extrait K-Bis ou l\'extrait du registre des métiers
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPageDelegationPouvoir(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPageDelegationPouvoir(uid, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadPageDelegationPouvoir']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload d\'un justificatif d\'identité
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPageJustificatifIdentite(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Utilisateur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPageJustificatifIdentite(uid, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadPageJustificatifIdentite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload du justificatif d\'identité de l\'entreprise (KBIS ou justificatif d\'inscription à l\'ordre des métiers)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPageJustificatifIdentiteEntreprise(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPageJustificatifIdentiteEntreprise(uid, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadPageJustificatifIdentiteEntreprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload d\'un côté d\'un justificatif d\'identité
         * @param {string} uid 
         * @param {boolean} isRecto 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPageJustificatifIdentite_2(uid: string, isRecto: boolean, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Utilisateur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPageJustificatifIdentite_2(uid, isRecto, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadPageJustificatifIdentite_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload d\'un justificatif d\'identité (passeport)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPagePasseport(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Utilisateur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPagePasseport(uid, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadPagePasseport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload du justificatif \'Récépissé de déclaration en préfecture\' (association)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPageRecepDeclaPref(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPageRecepDeclaPref(uid, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadPageRecepDeclaPref']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload du justificatif \'Récépissé d’insertion légale au Journal Officiel\' (association)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPageRecepInsertion(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPageRecepInsertion(uid, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadPageRecepInsertion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload des statuts de l\'entreprise
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPageStatuts(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entreprise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPageStatuts(uid, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadPageStatuts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary validation ou rejet d\'un consentement d\'un ou plusieurs salariés
         * @param {string} refInterne 
         * @param {string} idEmployee 
         * @param {boolean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validationConsent(refInterne: string, idEmployee: string, body: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionConsents>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validationConsent(refInterne, idEmployee, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.validationConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary active specified folders
         * @param {FolderUids} folderUids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activeFolders(folderUids: FolderUids, options?: RawAxiosRequestConfig): AxiosPromise<Array<Dossier>> {
            return localVarFp.activeFolders(folderUids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ajout d\'un commentaire sur un dossier
         * @param {Commentaire} commentaire 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommentaireDossier(commentaire: Commentaire, options?: RawAxiosRequestConfig): AxiosPromise<Commentaire> {
            return localVarFp.addCommentaireDossier(commentaire, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Annulation d\'une liasse de souscription
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annulerLiasse(uid: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.annulerLiasse(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive specified folders
         * @param {FolderUids} folderUids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveFolders(folderUids: FolderUids, options?: RawAxiosRequestConfig): AxiosPromise<Array<Dossier>> {
            return localVarFp.archiveFolders(folderUids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verification de cookie valide sinon retour des cgu en html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCgu(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.checkCgu(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Connexion à une session avec le token sso
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connecterSSO(options?: RawAxiosRequestConfig): AxiosPromise<Token> {
            return localVarFp.connecterSSO(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envoi des données du formulaire de contact
         * @param {ContactData} contactData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactData(contactData: ContactData, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.contactData(contactData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Création d\'un nouveau apporteur
         * @param {ApporteurLight} [apporteurLight] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApporteur(apporteurLight?: ApporteurLight, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createApporteur(apporteurLight, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary création d\'un document de la section de la bibliotheque
         * @param {string} idSection 
         * @param {BibliothequeDocument} [bibliothequeDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBibliothequeDocument(idSection: string, bibliothequeDocument?: BibliothequeDocument, options?: RawAxiosRequestConfig): AxiosPromise<BibliothequeDocument> {
            return localVarFp.createBibliothequeDocument(idSection, bibliothequeDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ajout d\'une section de la bibliotheque
         * @param {BibliothequeSection} bibliothequeSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBibliothequeSection(bibliothequeSection: BibliothequeSection, options?: RawAxiosRequestConfig): AxiosPromise<BibliothequeSection> {
            return localVarFp.createBibliothequeSection(bibliothequeSection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Création d\'un nouveau groupe (réseau apporteur)
         * @param {Groupe} groupe 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroupe(groupe: Groupe, options?: RawAxiosRequestConfig): AxiosPromise<Groupe> {
            return localVarFp.createGroupe(groupe, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Création d\'un nouvel inspecteur
         * @param {Inspecteur} inspecteur 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInspecteur(inspecteur: Inspecteur, options?: RawAxiosRequestConfig): AxiosPromise<Inspecteur> {
            return localVarFp.createInspecteur(inspecteur, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Création de la liasse de souscription
         * @param {DossierUid} dossierUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creerLiasseSouscription(dossierUid: DossierUid, options?: RawAxiosRequestConfig): AxiosPromise<LiasseSouscription> {
            return localVarFp.creerLiasseSouscription(dossierUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression d\'une liste d\'apporteurs
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApporteurs(requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteApporteurs(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification d\'un article de news
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticle(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteArticle(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary suppression d\'un document de la bibliotheque
         * @param {string} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBibliothequeDocument(idDocument: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBibliothequeDocument(idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary suppression d\'une section de la bibliotheque
         * @param {number} idSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBibliothequeSection(idSection: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBibliothequeSection(idSection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression d\'un commentaire sur un dossier
         * @param {string} dossierUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommentaireDossier(dossierUid: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCommentaireDossier(dossierUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression du fichier de consentement pour l\'utilisateur
         * @param {string} refInterne 
         * @param {string} idEmployee 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConsent(refInterne: string, idEmployee: string, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionConsents> {
            return localVarFp.deleteConsent(refInterne, idEmployee, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary suppression du fichier d\'un document de la bibliotheque
         * @param {string} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentFile(idDocument: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDocumentFile(idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression d\'un lien de la gamme de fonds
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGammeFondsLien(linkId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteGammeFondsLien(linkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression d\'un bandeau d\'informations
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInfoBanner(id: string, options?: RawAxiosRequestConfig): AxiosPromise<InfoBanner> {
            return localVarFp.deleteInfoBanner(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression du justificatif \'Carte professionnelle\' (profession libérale)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageCarteProfessionnelle(uid: string, nom?: string, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.deletePageCarteProfessionnelle(uid, nom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression du justificatif \'Copie du décret de reconnaissance de l’utilité publique\' (association)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageDecretReco(uid: string, nom?: string, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.deletePageDecretReco(uid, nom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression du Delegation du pouvoir
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageDelegationPouvoir(uid: string, nom?: string, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.deletePageDelegationPouvoir(uid, nom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression d\'une page d\'une pièce justificative de dossier de souscription
         * @param {string} uid UID du dossier de souscription
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageDocument(uid: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePageDocument(uid, fileMetadata, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression d\'un justificatif d\'identité
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageJustificatifIdentite(uid: string, nom?: string, options?: RawAxiosRequestConfig): AxiosPromise<Utilisateur> {
            return localVarFp.deletePageJustificatifIdentite(uid, nom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression d\'une page du justificatif de l\'entreprise
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageJustificatifIdentiteEntreprise(uid: string, nom?: string, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.deletePageJustificatifIdentiteEntreprise(uid, nom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression d\'un côté d\'un justificatif d\'identité
         * @param {string} uid 
         * @param {boolean} isRecto 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageJustificatifIdentite_1(uid: string, isRecto: boolean, nom?: string, options?: RawAxiosRequestConfig): AxiosPromise<Utilisateur> {
            return localVarFp.deletePageJustificatifIdentite_1(uid, isRecto, nom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression d\'un justificatif d\'identité (passeport)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePagePasseport(uid: string, nom?: string, options?: RawAxiosRequestConfig): AxiosPromise<Utilisateur> {
            return localVarFp.deletePagePasseport(uid, nom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression du justificatif \'Récépissé de déclaration en préfecture\' (association)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageRecepDeclaPref(uid: string, nom?: string, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.deletePageRecepDeclaPref(uid, nom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression du justificatif \'Récépissé d’insertion légale au Journal Officiel\' (association)
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageRecepInsertion(uid: string, nom?: string, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.deletePageRecepInsertion(uid, nom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression d\'une page des statuts de l\'entreprise
         * @param {string} uid 
         * @param {string} [nom] Nom du fichier à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageStatuts(uid: string, nom?: string, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.deletePageStatuts(uid, nom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suppression des données d\'un fichier source des commissions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSourceCommissions(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSourceCommissions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Création d\'une entreprise et initialisation d\'un dossier
         * @param {Entreprise} entreprise 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enregistrerEntreprise(entreprise: Entreprise, options?: RawAxiosRequestConfig): AxiosPromise<AjoutEntreprise> {
            return localVarFp.enregistrerEntreprise(entreprise, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permet de transmettre le bulletin d\'adhésion au client par mail
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        envoiMailAvantSignature(uid: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.envoiMailAvantSignature(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Génération d\'un token SSO pour le portail GES
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genererTokenSso(uid: string, options?: RawAxiosRequestConfig): AxiosPromise<TokenSso> {
            return localVarFp.genererTokenSso(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all active subscription folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActiveFolders(options?: RawAxiosRequestConfig): AxiosPromise<Array<DossierRecap>> {
            return localVarFp.getAllActiveFolders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération de toutes les activités présentes en base de données
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActivities(options?: RawAxiosRequestConfig): AxiosPromise<Array<Activity>> {
            return localVarFp.getAllActivities(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des apporteurs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllApporteurs(options?: RawAxiosRequestConfig): AxiosPromise<Array<Apporteur>> {
            return localVarFp.getAllApporteurs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all archived subscription folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllArchivedFolders(options?: RawAxiosRequestConfig): AxiosPromise<Array<DossierRecap>> {
            return localVarFp.getAllArchivedFolders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération de tous les consentements contenant à minima un fichier de consentement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConsents(options?: RawAxiosRequestConfig): AxiosPromise<Array<SubscriptionConsents>> {
            return localVarFp.getAllConsents(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des consentements de l\'apporteur d\'affaire (du token ou spécifié)
         * @param {string} [codeApporteur] Code de l\&#39;apporteur d\&#39;affaire. Si non fourni, utilise le code du bearer token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConsentsByBusinessProvider(codeApporteur?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SubscriptionConsents>> {
            return localVarFp.getAllConsentsByBusinessProvider(codeApporteur, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des groupes (= réseaux apporteurs)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGroupes(options?: RawAxiosRequestConfig): AxiosPromise<Array<Groupe>> {
            return localVarFp.getAllGroupes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des inspecteurs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInspecteurs(options?: RawAxiosRequestConfig): AxiosPromise<Array<Inspecteur>> {
            return localVarFp.getAllInspecteurs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoles(options?: RawAxiosRequestConfig): AxiosPromise<Array<Role>> {
            return localVarFp.getAllRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des sections de la bibliothèque ainsi que des documents associés
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSections(options?: RawAxiosRequestConfig): AxiosPromise<Array<BibliothequeSection>> {
            return localVarFp.getAllSections(options).then((request) => request(axios, basePath));
        },
        /**
         * L\'user_id auth0 de l\'apporteur à récupérer est stocké dans le Bearer token, dans la propriété sub
         * @summary Récupération des données d\'un apporteur pour l\'authentification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApporteurByAuthId(options?: RawAxiosRequestConfig): AxiosPromise<Apporteur> {
            return localVarFp.getApporteurByAuthId(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération d\'un document d\'actualité du portail
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleDocument(filename: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getArticleDocument(filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des articles des news
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticles(options?: RawAxiosRequestConfig): AxiosPromise<Array<Article>> {
            return localVarFp.getArticles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération d\'une section de la bibliotheque
         * @param {number} idSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBibliothequeSection(idSection: number, options?: RawAxiosRequestConfig): AxiosPromise<BibliothequeSection> {
            return localVarFp.getBibliothequeSection(idSection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération du commentaire lié à un dossier
         * @param {string} dossierUid La référence du dossier pour lequel on veut le commentaire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentaireDossier(dossierUid: string, options?: RawAxiosRequestConfig): AxiosPromise<Commentaire> {
            return localVarFp.getCommentaireDossier(dossierUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des commissions liées à un trimestre et un code apporteur
         * @param {string} annee 
         * @param {string} trimestre 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommissionByQuarter(annee: string, trimestre: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Commission>> {
            return localVarFp.getCommissionByQuarter(annee, trimestre, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération de la liste des commissions d\'un apporteur sous forme de tableau Excel
         * @param {string} annee 
         * @param {string} trimestre 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommissionsFile(annee: string, trimestre: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getCommissionsFile(annee, trimestre, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des informations d\'une entreprise depuis son SIRET
         * @param {string} siret Le numéro SIRET de l\&#39;entreprise
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyInfo(siret: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyInfo> {
            return localVarFp.getCompanyInfo(siret, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération d\'un dossier de consentement par sa référence Interne
         * @param {string} refInterne 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentByRefInterne(refInterne: string, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionConsents> {
            return localVarFp.getConsentByRefInterne(refInterne, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération du document de consentement d\'un des salariés pour la visualisation du back office
         * @param {string} refInterne 
         * @param {string} idEmployee 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentFileToPreview(refInterne: string, idEmployee: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getConsentFileToPreview(refInterne, idEmployee, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération du document pdf du modèle pour le consentement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentModel(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getConsentModel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération de la liste des pays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(options?: RawAxiosRequestConfig): AxiosPromise<Array<Pays>> {
            return localVarFp.getCountries(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des critères de financiers, qualitatifs et RSE associés à un id de secteur d\'activité
         * @param {number} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriteria(activityId: number, options?: RawAxiosRequestConfig): AxiosPromise<CompanySector> {
            return localVarFp.getCriteria(activityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération de la liste des tunnels personnalisés
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomTunnels(options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomTunnelData>> {
            return localVarFp.getCustomTunnels(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération d\'un fichier à un document de la bibliothèque
         * @param {string} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentFile(idDocument: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUrl> {
            return localVarFp.getDocumentFile(idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération du dossier de souscription
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDossier(uid: string, options?: RawAxiosRequestConfig): AxiosPromise<Dossier> {
            return localVarFp.getDossier(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des documents contractuels d\'un dossier
         * @param {string} dossierUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDossierContractDocuments(dossierUid: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getDossierContractDocuments(dossierUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération du dossier de souscription complet
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDossierDetails(uid: string, options?: RawAxiosRequestConfig): AxiosPromise<DossierAvecEntreprise> {
            return localVarFp.getDossierDetails(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des informations de l\'entreprise
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntreprise(uid: string, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.getEntreprise(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des évènements du domaine Plan Epargne Salarial selon différents critères
         * @param {string} [dateDebut] Recherche des évènements à partir de cette date / Format -&gt; jj/MM/YYYY
         * @param {string} [dateFin] Recherche des évènements jusqu\&#39;à cette date / Format -&gt; jj/MM/YYYY
         * @param {string} [entityName] Nom de l\&#39;entité concerné par l\&#39;évènement.
         * @param {string} [entityUid] uid de l\&#39;entité concernée par l\&#39;évènement. Il se trouve dans les metadatas
         * @param {string} [eventType] Nom de l\&#39;évènement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsPlan(dateDebut?: string, dateFin?: string, entityName?: string, entityUid?: string, eventType?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventData>> {
            return localVarFp.getEventsPlan(dateDebut, dateFin, entityName, entityUid, eventType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des évènements du domaine Référentiel Organisationnel selon différents critères
         * @param {string} [dateDebut] Recherche des évènements à partir de cette date / Format -&gt; jj/MM/YYYY
         * @param {string} [dateFin] Recherche des évènements jusqu\&#39;à cette date / Format -&gt; jj/MM/YYYY
         * @param {string} [entityName] Nom de l\&#39;entité concerné par l\&#39;évènement.
         * @param {string} [entityUid] uid de l\&#39;entité concernée par l\&#39;évènement. Il se trouve dans les metadatas
         * @param {string} [eventType] Nom de l\&#39;évènement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsReferentielOrga(dateDebut?: string, dateFin?: string, entityName?: string, entityUid?: string, eventType?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventData>> {
            return localVarFp.getEventsReferentielOrga(dateDebut, dateFin, entityName, entityUid, eventType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération d\'un fichier du dossier custom_tunnels du S3
         * @param {string} reseau 
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile(reseau: string, filename: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getFile(reseau, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération de données de la rubrique \'Formations\' du portail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormations(options?: RawAxiosRequestConfig): AxiosPromise<Array<Formations>> {
            return localVarFp.getFormations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération d\'un URL vers le S3 pour la vidéo
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormationsUrl(name: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUrl> {
            return localVarFp.getFormationsUrl(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des liens de la gamme de fonds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGammeFonds(options?: RawAxiosRequestConfig): AxiosPromise<GammeFonds> {
            return localVarFp.getGammeFonds(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envoie des données de la simulation d\'intéressement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorDatas(options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneratorData>> {
            return localVarFp.getGeneratorDatas(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des bandeaux d\'informations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfoBanners(options?: RawAxiosRequestConfig): AxiosPromise<ListInfoBanners> {
            return localVarFp.getInfoBanners(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération valeurs du PASS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPASS(options?: RawAxiosRequestConfig): AxiosPromise<Pass> {
            return localVarFp.getPASS(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération du document pdf pour les Performances cumulées
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerformancesCumulees(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getPerformancesCumulees(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Requête une URL signée d\'upload AWS pour l\'ajout d\'un fichier de source commissions
         * @param {string} id 
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresignedUploadURLForCommissionsFile(id: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): AxiosPromise<UploadUrl> {
            return localVarFp.getPresignedUploadURLForCommissionsFile(id, fileMetadata, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Requête une URL signée d\'upload AWS pour l\'ajout d\'un fichier dans la bibliothèque
         * @param {string} idDocument 
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresignedUploadURLForLibraryDocumentFile(idDocument: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): AxiosPromise<UploadUrl> {
            return localVarFp.getPresignedUploadURLForLibraryDocumentFile(idDocument, fileMetadata, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Requête une URL signée d\'upload AWS pour une page de pièce justificative de dossier de souscription
         * @param {string} uid UID du dossier de souscription
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresignedUploadURLForPageDocument(uid: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): AxiosPromise<UploadUrl> {
            return localVarFp.getPresignedUploadURLForPageDocument(uid, fileMetadata, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération d\'une URL présignée pour déposer le document des Performances cumulées
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresignedUploadURLForPerformancesCumulees(fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): AxiosPromise<UploadUrl> {
            return localVarFp.getPresignedUploadURLForPerformancesCumulees(fileMetadata, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Génère un fichier excel avec le rapport de dossies de souscription du tunnel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapports(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getRapports(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération de la liste des récaps des commissions d\'un apporteur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecapCommissionsApporteur(options?: RawAxiosRequestConfig): AxiosPromise<Array<RecapCommission>> {
            return localVarFp.getRecapCommissionsApporteur(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération activation du service avec son nom
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceByName(name: string, options?: RawAxiosRequestConfig): AxiosPromise<ServiceActivation> {
            return localVarFp.getServiceByName(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération activation des services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices(options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceActivation>> {
            return localVarFp.getServices(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des données simplifiées des dossiers de souscription actifs pour un apporteur
         * @param {string} [codeApporteur] Code de l\&#39;apporteur pour filtrer les dossiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimpleActiveFolders(codeApporteur?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DossierAvecEntrepriseRecap>> {
            return localVarFp.getSimpleActiveFolders(codeApporteur, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération du document zip pour le Simulateur CAMPAGNE+ de suivi d\'activité
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulateurCampagnePlus(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getSimulateurCampagnePlus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récuperation d\'une URL présignée d\'un fichier de source commissions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceCommissionsFile(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUrl> {
            return localVarFp.getSourceCommissionsFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération de la liste des fichiers sources de commissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourcesCommissions(options?: RawAxiosRequestConfig): AxiosPromise<Array<SourceCommissions>> {
            return localVarFp.getSourcesCommissions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération de la page de template de test interprété par Thymeleaf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate(options?: RawAxiosRequestConfig): AxiosPromise<TemplateMail> {
            return localVarFp.getTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération du fichier excel avec le transfers plan épargne salariale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferts(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getTransferts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des informations de l\'utilisateur
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtilisateur(uid: string, options?: RawAxiosRequestConfig): AxiosPromise<Utilisateur> {
            return localVarFp.getUtilisateur(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Initialise un dossier de souscription avec les données d\'un apporteur d\'affaire
         * @param {InitDossier} [initDossier] Dossier avec apporteur d\&#39;affaire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initDossier(initDossier?: InitDossier, options?: RawAxiosRequestConfig): AxiosPromise<Dossier> {
            return localVarFp.initDossier(initDossier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Webhook utilisé par Docusign pour récupérer la liasse signée
         * @param {string} tenant 
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifierLiasse(tenant: string, uid: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notifierLiasse(tenant, uid, options).then((request) => request(axios, basePath));
        },
        /**
         * Enregistre en BD l\'ajout du fichier de la bibliothèque. Route appelée après qu\'un upload AWS ait réussi côté client.
         * @summary Enregistre l\'ajout d\'un fichier de la bibliothèque
         * @param {string} idDocument 
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyLibraryDocumentFileUploaded(idDocument: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): AxiosPromise<BibliothequeDocument> {
            return localVarFp.notifyLibraryDocumentFileUploaded(idDocument, fileMetadata, options).then((request) => request(axios, basePath));
        },
        /**
         * Enregistre en BD l\'ajout de la page de la pièce justificative pour un dossier de souscription. Route appelée après qu\'un upload AWS ait réussi côté client.
         * @summary Enregistre l\'ajout de la page de la pièce justificative pour un dossier de souscription
         * @param {string} uid UID du dossier de souscription
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyPageDocumentUploaded(uid: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notifyPageDocumentUploaded(uid, fileMetadata, options).then((request) => request(axios, basePath));
        },
        /**
         * Notifie le serveur après la réussite de l\'upload du document vers AWS S3.
         * @summary Enregistrement du document des Performances cumulées après son dépôt
         * @param {FileMetadata} fileMetadata 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyPerformancesCumuleesUploaded(fileMetadata: FileMetadata, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notifyPerformancesCumuleesUploaded(fileMetadata, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ajout d\'un article de news
         * @param {Article} article Article
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postArticle(article: Article, options?: RawAxiosRequestConfig): AxiosPromise<Article> {
            return localVarFp.postArticle(article, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification de la gamme de fonds
         * @param {GammeFonds} gammeFonds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGammeFonds(gammeFonds: GammeFonds, options?: RawAxiosRequestConfig): AxiosPromise<GammeFonds> {
            return localVarFp.postGammeFonds(gammeFonds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Création d\'un lien de la gamme de fonds
         * @param {LienGammeFonds} lienGammeFonds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGammeFondsLien(lienGammeFonds: LienGammeFonds, options?: RawAxiosRequestConfig): AxiosPromise<LienGammeFonds> {
            return localVarFp.postGammeFondsLien(lienGammeFonds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ajout d\'un bandeau d\'informations
         * @param {string} text 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInfoBanner(text: string, options?: RawAxiosRequestConfig): AxiosPromise<InfoBanner> {
            return localVarFp.postInfoBanner(text, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enregistrement des données d\'un fichier source des commissions
         * @param {SourceCommissions} sourceCommissions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSourceCommissions(sourceCommissions: SourceCommissions, options?: RawAxiosRequestConfig): AxiosPromise<SourceCommissions> {
            return localVarFp.postSourceCommissions(sourceCommissions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification d\'un article de news
         * @param {string} id 
         * @param {Article} article 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putArticle(id: string, article: Article, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putArticle(id, article, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification d\'un lien de la gamme de fonds
         * @param {LienGammeFonds} lienGammeFonds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGammeFondsLien(lienGammeFonds: LienGammeFonds, options?: RawAxiosRequestConfig): AxiosPromise<LienGammeFonds> {
            return localVarFp.putGammeFondsLien(lienGammeFonds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification d\'un bandeau d\'information
         * @param {string} id 
         * @param {InfoBanner} infoBanner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putInfoBanner(id: string, infoBanner: InfoBanner, options?: RawAxiosRequestConfig): AxiosPromise<InfoBanner> {
            return localVarFp.putInfoBanner(id, infoBanner, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Réception des données au parcours intermédiaire de la simulation d\'intéressement
         * @param {File} quickRecapPdf 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quickSimulationData(quickRecapPdf: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.quickSimulationData(quickRecapPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Régénération d\'un token JWT pour le tunel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rafraichirToken(options?: RawAxiosRequestConfig): AxiosPromise<Token> {
            return localVarFp.rafraichirToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recherche une entreprise dans la base SIRENE à partir du SIRET
         * @param {string} [siret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechercherEntreprise(siret?: string, options?: RawAxiosRequestConfig): AxiosPromise<SireneInfo> {
            return localVarFp.rechercherEntreprise(siret, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération de l\'URL DocuSign pour que l\'utilisateur puisse signer sa liasse de souscription
         * @param {string} uid 
         * @param {string} [redirectUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recupererUrlSignature(uid: string, redirectUrl?: string, options?: RawAxiosRequestConfig): AxiosPromise<UrlSignature> {
            return localVarFp.recupererUrlSignature(uid, redirectUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Réception des données pour la sauvegarde d\'un tunnel personnalisé
         * @param {CustomTunnelData} customTunnelData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTunnel(customTunnelData: CustomTunnelData, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveTunnel(customTunnelData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des informations du dossier de souscription à partir de l\'uid entreprise
         * @param {string} [uidEntreprise] id de l\&#39;entreprise du dossier
         * @param {string} [codeApporteur] le code apporteur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDossierSouscription(uidEntreprise?: string, codeApporteur?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DossierAvecEntreprise>> {
            return localVarFp.searchDossierSouscription(uidEntreprise, codeApporteur, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Réception des données de la simulation d\'intéressement
         * @param {GeneratorData} generatorData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulationData(generatorData: GeneratorData, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.simulationData(generatorData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permet de transmettre le dossier PEI PERcoi finalisé
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transmettreDossier(uid: string, options?: RawAxiosRequestConfig): AxiosPromise<Dossier> {
            return localVarFp.transmettreDossier(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification de l\'abondement PEE/PERCOI de l\'utilisateur
         * @param {string} uid 
         * @param {Dispositifs} dispositifs 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAbondements(uid: string, dispositifs: Dispositifs, options?: RawAxiosRequestConfig): AxiosPromise<Dossier> {
            return localVarFp.updateAbondements(uid, dispositifs, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ajout de l’Annexe KYC Amundi dans la liasse de documents pour signature électronique
         * @param {string} uid 
         * @param {DonneesKYC} donneesKYC 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnexeKYC(uid: string, donneesKYC: DonneesKYC, options?: RawAxiosRequestConfig): AxiosPromise<Dossier> {
            return localVarFp.updateAnnexeKYC(uid, donneesKYC, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mise à jour d\'un apporteur de part son UUID
         * @param {string} uuid UUID Apporteur
         * @param {ApporteurWithFoldersId} [apporteurWithFoldersId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApporteur(uuid: string, apporteurWithFoldersId?: ApporteurWithFoldersId, options?: RawAxiosRequestConfig): AxiosPromise<Apporteur> {
            return localVarFp.updateApporteur(uuid, apporteurWithFoldersId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification du téléphone d\'un apporteur
         * @param {ApporteurTelephoneUpdate} [apporteurTelephoneUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApporteurTelephone(apporteurTelephoneUpdate?: ApporteurTelephoneUpdate, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateApporteurTelephone(apporteurTelephoneUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification d\'un document de la bibliotheque
         * @param {string} idDocument 
         * @param {BibliothequeDocument} [bibliothequeDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBibliothequeDocument(idDocument: string, bibliothequeDocument?: BibliothequeDocument, options?: RawAxiosRequestConfig): AxiosPromise<BibliothequeDocument> {
            return localVarFp.updateBibliothequeDocument(idDocument, bibliothequeDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification d\'une section de la bibliotheque
         * @param {number} idSection 
         * @param {BibliothequeSection} bibliothequeSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBibliothequeSection(idSection: number, bibliothequeSection: BibliothequeSection, options?: RawAxiosRequestConfig): AxiosPromise<BibliothequeSection> {
            return localVarFp.updateBibliothequeSection(idSection, bibliothequeSection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modifiation des colleges et taux
         * @param {string} uid 
         * @param {CategoriesSalaries} categoriesSalaries 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoriesSalaries(uid: string, categoriesSalaries: CategoriesSalaries, options?: RawAxiosRequestConfig): AxiosPromise<CategoriesSalaries> {
            return localVarFp.updateCategoriesSalaries(uid, categoriesSalaries, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification du commentaire lié à un dossier
         * @param {Commentaire} commentaire 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommentaireDossier(commentaire: Commentaire, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCommentaireDossier(commentaire, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Renseignement du RIB de l\'utilisateur
         * @param {string} uid 
         * @param {CompteDePrelevement} compteDePrelevement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompteDePrelevement(uid: string, compteDePrelevement: CompteDePrelevement, options?: RawAxiosRequestConfig): AxiosPromise<Dossier> {
            return localVarFp.updateCompteDePrelevement(uid, compteDePrelevement, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Depot de consentement d\'un salarié
         * @param {string} refInterne 
         * @param {string} idEmployee 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConsent(refInterne: string, idEmployee: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionConsents> {
            return localVarFp.updateConsent(refInterne, idEmployee, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification des informations de l\'entreprise
         * @param {string} uid 
         * @param {Entreprise} entreprise 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntreprise(uid: string, entreprise: Entreprise, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.updateEntreprise(uid, entreprise, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permet d\'ouvrir/fermer le flux HARVEST pour les distributeurs spécifiés
         * @param {boolean} toActivate ouverture/fermeture du flux
         * @param {Array<string>} [requestBody] liste des apporteurs uuids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFluxHarvest(toActivate: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateFluxHarvest(toActivate, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification de la fonction du dirigeant dans l\'entreprise
         * @param {string} uid 
         * @param {Fonction} fonction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFonctionDansEntreprise(uid: string, fonction: Fonction, options?: RawAxiosRequestConfig): AxiosPromise<Utilisateur> {
            return localVarFp.updateFonctionDansEntreprise(uid, fonction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modifiation des frais de contrat dans le dossier
         * @param {string} uid 
         * @param {FraisContrat} fraisContrat 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFraisContrat(uid: string, fraisContrat: FraisContrat, options?: RawAxiosRequestConfig): AxiosPromise<FraisContrat> {
            return localVarFp.updateFraisContrat(uid, fraisContrat, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modifiation choix de garantie de prevoyance au dossier
         * @param {string} uid 
         * @param {GarantiesPrevoyance} garantiesPrevoyance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGarantiesPrevoyance(uid: string, garantiesPrevoyance: GarantiesPrevoyance, options?: RawAxiosRequestConfig): AxiosPromise<GarantiesPrevoyance> {
            return localVarFp.updateGarantiesPrevoyance(uid, garantiesPrevoyance, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification des informations de l\'utilisateur
         * @param {string} uid 
         * @param {Dirigeant} dirigeant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformationsUtilisateur(uid: string, dirigeant: Dirigeant, options?: RawAxiosRequestConfig): AxiosPromise<Utilisateur> {
            return localVarFp.updateInformationsUtilisateur(uid, dirigeant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mettre en place de l\'intérèssement ou non
         * @param {string} uid 
         * @param {Interessement} interessement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInteressement(uid: string, interessement: Interessement, options?: RawAxiosRequestConfig): AxiosPromise<Dossier> {
            return localVarFp.updateInteressement(uid, interessement, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mise en place de la participation ou non en cas d\'entreprise de plus de 50 salariés
         * @param {string} uid 
         * @param {Participation} participation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParticipation(uid: string, participation: Participation, options?: RawAxiosRequestConfig): AxiosPromise<Dossier> {
            return localVarFp.updateParticipation(uid, participation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mise à jour des valeurs du PASS
         * @param {Pass} pass 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePass(pass: Pass, options?: RawAxiosRequestConfig): AxiosPromise<Pass> {
            return localVarFp.updatePass(pass, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Informations à renseigner en cas de transfert d\'un PEE / PERCO
         * @param {string} uid 
         * @param {PlanExistant} planExistant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanExistant(uid: string, planExistant: PlanExistant, options?: RawAxiosRequestConfig): AxiosPromise<Dossier> {
            return localVarFp.updatePlanExistant(uid, planExistant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification des positions des sections de la bibliotheque
         * @param {Array<BibliothequeSection>} bibliothequeSection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePositionSections(bibliothequeSection: Array<BibliothequeSection>, options?: RawAxiosRequestConfig): AxiosPromise<Array<BibliothequeSection>> {
            return localVarFp.updatePositionSections(bibliothequeSection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mise à jour booléen activation du service
         * @param {ServiceActivation} serviceActivation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateService(serviceActivation: ServiceActivation, options?: RawAxiosRequestConfig): AxiosPromise<ServiceActivation> {
            return localVarFp.updateService(serviceActivation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Changement de l\'étape
         * @param {string} uid 
         * @param {EtapeDossier} [etapeDossier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStep(uid: string, etapeDossier?: EtapeDossier, options?: RawAxiosRequestConfig): AxiosPromise<Dossier> {
            return localVarFp.updateStep(uid, etapeDossier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mise à jour des informations de tarification
         * @param {string} uid 
         * @param {Tarification} tarification 
         * @param {boolean} [sauvegardeSeule] Si true, sauvegarde la tarification sans changer l\&#39;étape du dossier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTarification(uid: string, tarification: Tarification, sauvegardeSeule?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Dossier> {
            return localVarFp.updateTarification(uid, tarification, sauvegardeSeule, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload des fichiers utilisé pour un tunnel personnalisé d\'un réseau
         * @param {string} reseau 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomTunnelFiles(reseau: string, files?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadCustomTunnelFiles(reseau, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload du justificatif \'Carte professionnelle\' (profession libérale)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageCarteProfessionnelle(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.uploadPageCarteProfessionnelle(uid, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload du justificatif \'Copie du décret de reconnaissance de l’utilité publique\' (association)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageDecretReco(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.uploadPageDecretReco(uid, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload de la copie du pouvoir donné pour engager l\'entreprise en matière d\'épargne salariale si le nom du signataire n’apparaît pas sur l\'extrait K-Bis ou l\'extrait du registre des métiers
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageDelegationPouvoir(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.uploadPageDelegationPouvoir(uid, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload d\'un justificatif d\'identité
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageJustificatifIdentite(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Utilisateur> {
            return localVarFp.uploadPageJustificatifIdentite(uid, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload du justificatif d\'identité de l\'entreprise (KBIS ou justificatif d\'inscription à l\'ordre des métiers)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageJustificatifIdentiteEntreprise(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.uploadPageJustificatifIdentiteEntreprise(uid, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload d\'un côté d\'un justificatif d\'identité
         * @param {string} uid 
         * @param {boolean} isRecto 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageJustificatifIdentite_2(uid: string, isRecto: boolean, files: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Utilisateur> {
            return localVarFp.uploadPageJustificatifIdentite_2(uid, isRecto, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload d\'un justificatif d\'identité (passeport)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPagePasseport(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Utilisateur> {
            return localVarFp.uploadPagePasseport(uid, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload du justificatif \'Récépissé de déclaration en préfecture\' (association)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageRecepDeclaPref(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.uploadPageRecepDeclaPref(uid, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload du justificatif \'Récépissé d’insertion légale au Journal Officiel\' (association)
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageRecepInsertion(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.uploadPageRecepInsertion(uid, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload des statuts de l\'entreprise
         * @param {string} uid 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPageStatuts(uid: string, files: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Entreprise> {
            return localVarFp.uploadPageStatuts(uid, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary validation ou rejet d\'un consentement d\'un ou plusieurs salariés
         * @param {string} refInterne 
         * @param {string} idEmployee 
         * @param {boolean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validationConsent(refInterne: string, idEmployee: string, body: boolean, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionConsents> {
            return localVarFp.validationConsent(refInterne, idEmployee, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary active specified folders
     * @param {FolderUids} folderUids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public activeFolders(folderUids: FolderUids, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).activeFolders(folderUids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ajout d\'un commentaire sur un dossier
     * @param {Commentaire} commentaire 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCommentaireDossier(commentaire: Commentaire, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addCommentaireDossier(commentaire, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Annulation d\'une liasse de souscription
     * @param {string} uid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public annulerLiasse(uid: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).annulerLiasse(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive specified folders
     * @param {FolderUids} folderUids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public archiveFolders(folderUids: FolderUids, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).archiveFolders(folderUids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verification de cookie valide sinon retour des cgu en html
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkCgu(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkCgu(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Connexion à une session avec le token sso
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public connecterSSO(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).connecterSSO(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envoi des données du formulaire de contact
     * @param {ContactData} contactData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public contactData(contactData: ContactData, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).contactData(contactData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Création d\'un nouveau apporteur
     * @param {ApporteurLight} [apporteurLight] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createApporteur(apporteurLight?: ApporteurLight, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createApporteur(apporteurLight, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary création d\'un document de la section de la bibliotheque
     * @param {string} idSection 
     * @param {BibliothequeDocument} [bibliothequeDocument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createBibliothequeDocument(idSection: string, bibliothequeDocument?: BibliothequeDocument, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createBibliothequeDocument(idSection, bibliothequeDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ajout d\'une section de la bibliotheque
     * @param {BibliothequeSection} bibliothequeSection 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createBibliothequeSection(bibliothequeSection: BibliothequeSection, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createBibliothequeSection(bibliothequeSection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Création d\'un nouveau groupe (réseau apporteur)
     * @param {Groupe} groupe 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createGroupe(groupe: Groupe, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createGroupe(groupe, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Création d\'un nouvel inspecteur
     * @param {Inspecteur} inspecteur 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createInspecteur(inspecteur: Inspecteur, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createInspecteur(inspecteur, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Création de la liasse de souscription
     * @param {DossierUid} dossierUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public creerLiasseSouscription(dossierUid: DossierUid, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).creerLiasseSouscription(dossierUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression d\'une liste d\'apporteurs
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteApporteurs(requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteApporteurs(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification d\'un article de news
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteArticle(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteArticle(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary suppression d\'un document de la bibliotheque
     * @param {string} idDocument 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteBibliothequeDocument(idDocument: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteBibliothequeDocument(idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary suppression d\'une section de la bibliotheque
     * @param {number} idSection 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteBibliothequeSection(idSection: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteBibliothequeSection(idSection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression d\'un commentaire sur un dossier
     * @param {string} dossierUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCommentaireDossier(dossierUid: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteCommentaireDossier(dossierUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression du fichier de consentement pour l\'utilisateur
     * @param {string} refInterne 
     * @param {string} idEmployee 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteConsent(refInterne: string, idEmployee: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteConsent(refInterne, idEmployee, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary suppression du fichier d\'un document de la bibliotheque
     * @param {string} idDocument 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDocumentFile(idDocument: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteDocumentFile(idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression d\'un lien de la gamme de fonds
     * @param {string} linkId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteGammeFondsLien(linkId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteGammeFondsLien(linkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression d\'un bandeau d\'informations
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteInfoBanner(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteInfoBanner(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression du justificatif \'Carte professionnelle\' (profession libérale)
     * @param {string} uid 
     * @param {string} [nom] Nom du fichier à supprimer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePageCarteProfessionnelle(uid: string, nom?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePageCarteProfessionnelle(uid, nom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression du justificatif \'Copie du décret de reconnaissance de l’utilité publique\' (association)
     * @param {string} uid 
     * @param {string} [nom] Nom du fichier à supprimer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePageDecretReco(uid: string, nom?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePageDecretReco(uid, nom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression du Delegation du pouvoir
     * @param {string} uid 
     * @param {string} [nom] Nom du fichier à supprimer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePageDelegationPouvoir(uid: string, nom?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePageDelegationPouvoir(uid, nom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression d\'une page d\'une pièce justificative de dossier de souscription
     * @param {string} uid UID du dossier de souscription
     * @param {FileMetadata} fileMetadata 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePageDocument(uid: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePageDocument(uid, fileMetadata, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression d\'un justificatif d\'identité
     * @param {string} uid 
     * @param {string} [nom] Nom du fichier à supprimer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePageJustificatifIdentite(uid: string, nom?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePageJustificatifIdentite(uid, nom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression d\'une page du justificatif de l\'entreprise
     * @param {string} uid 
     * @param {string} [nom] Nom du fichier à supprimer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePageJustificatifIdentiteEntreprise(uid: string, nom?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePageJustificatifIdentiteEntreprise(uid, nom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression d\'un côté d\'un justificatif d\'identité
     * @param {string} uid 
     * @param {boolean} isRecto 
     * @param {string} [nom] Nom du fichier à supprimer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePageJustificatifIdentite_1(uid: string, isRecto: boolean, nom?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePageJustificatifIdentite_1(uid, isRecto, nom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression d\'un justificatif d\'identité (passeport)
     * @param {string} uid 
     * @param {string} [nom] Nom du fichier à supprimer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePagePasseport(uid: string, nom?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePagePasseport(uid, nom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression du justificatif \'Récépissé de déclaration en préfecture\' (association)
     * @param {string} uid 
     * @param {string} [nom] Nom du fichier à supprimer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePageRecepDeclaPref(uid: string, nom?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePageRecepDeclaPref(uid, nom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression du justificatif \'Récépissé d’insertion légale au Journal Officiel\' (association)
     * @param {string} uid 
     * @param {string} [nom] Nom du fichier à supprimer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePageRecepInsertion(uid: string, nom?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePageRecepInsertion(uid, nom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression d\'une page des statuts de l\'entreprise
     * @param {string} uid 
     * @param {string} [nom] Nom du fichier à supprimer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePageStatuts(uid: string, nom?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePageStatuts(uid, nom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suppression des données d\'un fichier source des commissions
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSourceCommissions(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteSourceCommissions(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Création d\'une entreprise et initialisation d\'un dossier
     * @param {Entreprise} entreprise 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public enregistrerEntreprise(entreprise: Entreprise, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).enregistrerEntreprise(entreprise, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permet de transmettre le bulletin d\'adhésion au client par mail
     * @param {string} uid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public envoiMailAvantSignature(uid: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).envoiMailAvantSignature(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Génération d\'un token SSO pour le portail GES
     * @param {string} uid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public genererTokenSso(uid: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).genererTokenSso(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all active subscription folders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllActiveFolders(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllActiveFolders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération de toutes les activités présentes en base de données
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllActivities(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllActivities(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des apporteurs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllApporteurs(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllApporteurs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all archived subscription folders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllArchivedFolders(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllArchivedFolders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération de tous les consentements contenant à minima un fichier de consentement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllConsents(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllConsents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des consentements de l\'apporteur d\'affaire (du token ou spécifié)
     * @param {string} [codeApporteur] Code de l\&#39;apporteur d\&#39;affaire. Si non fourni, utilise le code du bearer token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllConsentsByBusinessProvider(codeApporteur?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllConsentsByBusinessProvider(codeApporteur, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des groupes (= réseaux apporteurs)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllGroupes(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllGroupes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des inspecteurs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllInspecteurs(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllInspecteurs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllRoles(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des sections de la bibliothèque ainsi que des documents associés
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllSections(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllSections(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * L\'user_id auth0 de l\'apporteur à récupérer est stocké dans le Bearer token, dans la propriété sub
     * @summary Récupération des données d\'un apporteur pour l\'authentification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApporteurByAuthId(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getApporteurByAuthId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération d\'un document d\'actualité du portail
     * @param {string} filename 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getArticleDocument(filename: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getArticleDocument(filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des articles des news
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getArticles(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getArticles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération d\'une section de la bibliotheque
     * @param {number} idSection 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBibliothequeSection(idSection: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBibliothequeSection(idSection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération du commentaire lié à un dossier
     * @param {string} dossierUid La référence du dossier pour lequel on veut le commentaire
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCommentaireDossier(dossierUid: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommentaireDossier(dossierUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des commissions liées à un trimestre et un code apporteur
     * @param {string} annee 
     * @param {string} trimestre 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCommissionByQuarter(annee: string, trimestre: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommissionByQuarter(annee, trimestre, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération de la liste des commissions d\'un apporteur sous forme de tableau Excel
     * @param {string} annee 
     * @param {string} trimestre 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCommissionsFile(annee: string, trimestre: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommissionsFile(annee, trimestre, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des informations d\'une entreprise depuis son SIRET
     * @param {string} siret Le numéro SIRET de l\&#39;entreprise
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompanyInfo(siret: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCompanyInfo(siret, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération d\'un dossier de consentement par sa référence Interne
     * @param {string} refInterne 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConsentByRefInterne(refInterne: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getConsentByRefInterne(refInterne, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération du document de consentement d\'un des salariés pour la visualisation du back office
     * @param {string} refInterne 
     * @param {string} idEmployee 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConsentFileToPreview(refInterne: string, idEmployee: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getConsentFileToPreview(refInterne, idEmployee, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération du document pdf du modèle pour le consentement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConsentModel(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getConsentModel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération de la liste des pays
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCountries(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCountries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des critères de financiers, qualitatifs et RSE associés à un id de secteur d\'activité
     * @param {number} activityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCriteria(activityId: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCriteria(activityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération de la liste des tunnels personnalisés
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomTunnels(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCustomTunnels(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération d\'un fichier à un document de la bibliothèque
     * @param {string} idDocument 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDocumentFile(idDocument: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDocumentFile(idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération du dossier de souscription
     * @param {string} uid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDossier(uid: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDossier(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des documents contractuels d\'un dossier
     * @param {string} dossierUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDossierContractDocuments(dossierUid: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDossierContractDocuments(dossierUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération du dossier de souscription complet
     * @param {string} uid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDossierDetails(uid: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDossierDetails(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des informations de l\'entreprise
     * @param {string} uid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEntreprise(uid: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEntreprise(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des évènements du domaine Plan Epargne Salarial selon différents critères
     * @param {string} [dateDebut] Recherche des évènements à partir de cette date / Format -&gt; jj/MM/YYYY
     * @param {string} [dateFin] Recherche des évènements jusqu\&#39;à cette date / Format -&gt; jj/MM/YYYY
     * @param {string} [entityName] Nom de l\&#39;entité concerné par l\&#39;évènement.
     * @param {string} [entityUid] uid de l\&#39;entité concernée par l\&#39;évènement. Il se trouve dans les metadatas
     * @param {string} [eventType] Nom de l\&#39;évènement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEventsPlan(dateDebut?: string, dateFin?: string, entityName?: string, entityUid?: string, eventType?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEventsPlan(dateDebut, dateFin, entityName, entityUid, eventType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des évènements du domaine Référentiel Organisationnel selon différents critères
     * @param {string} [dateDebut] Recherche des évènements à partir de cette date / Format -&gt; jj/MM/YYYY
     * @param {string} [dateFin] Recherche des évènements jusqu\&#39;à cette date / Format -&gt; jj/MM/YYYY
     * @param {string} [entityName] Nom de l\&#39;entité concerné par l\&#39;évènement.
     * @param {string} [entityUid] uid de l\&#39;entité concernée par l\&#39;évènement. Il se trouve dans les metadatas
     * @param {string} [eventType] Nom de l\&#39;évènement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEventsReferentielOrga(dateDebut?: string, dateFin?: string, entityName?: string, entityUid?: string, eventType?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEventsReferentielOrga(dateDebut, dateFin, entityName, entityUid, eventType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération d\'un fichier du dossier custom_tunnels du S3
     * @param {string} reseau 
     * @param {string} filename 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFile(reseau: string, filename: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFile(reseau, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération de données de la rubrique \'Formations\' du portail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFormations(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFormations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération d\'un URL vers le S3 pour la vidéo
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFormationsUrl(name: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFormationsUrl(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des liens de la gamme de fonds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGammeFonds(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getGammeFonds(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envoie des données de la simulation d\'intéressement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGeneratorDatas(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getGeneratorDatas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des bandeaux d\'informations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInfoBanners(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getInfoBanners(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération valeurs du PASS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPASS(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPASS(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération du document pdf pour les Performances cumulées
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPerformancesCumulees(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPerformancesCumulees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Requête une URL signée d\'upload AWS pour l\'ajout d\'un fichier de source commissions
     * @param {string} id 
     * @param {FileMetadata} fileMetadata 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPresignedUploadURLForCommissionsFile(id: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPresignedUploadURLForCommissionsFile(id, fileMetadata, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Requête une URL signée d\'upload AWS pour l\'ajout d\'un fichier dans la bibliothèque
     * @param {string} idDocument 
     * @param {FileMetadata} fileMetadata 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPresignedUploadURLForLibraryDocumentFile(idDocument: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPresignedUploadURLForLibraryDocumentFile(idDocument, fileMetadata, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Requête une URL signée d\'upload AWS pour une page de pièce justificative de dossier de souscription
     * @param {string} uid UID du dossier de souscription
     * @param {FileMetadata} fileMetadata 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPresignedUploadURLForPageDocument(uid: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPresignedUploadURLForPageDocument(uid, fileMetadata, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération d\'une URL présignée pour déposer le document des Performances cumulées
     * @param {FileMetadata} fileMetadata 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPresignedUploadURLForPerformancesCumulees(fileMetadata: FileMetadata, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPresignedUploadURLForPerformancesCumulees(fileMetadata, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Génère un fichier excel avec le rapport de dossies de souscription du tunnel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRapports(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRapports(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération de la liste des récaps des commissions d\'un apporteur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRecapCommissionsApporteur(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRecapCommissionsApporteur(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération activation du service avec son nom
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getServiceByName(name: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getServiceByName(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération activation des services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getServices(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getServices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des données simplifiées des dossiers de souscription actifs pour un apporteur
     * @param {string} [codeApporteur] Code de l\&#39;apporteur pour filtrer les dossiers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSimpleActiveFolders(codeApporteur?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSimpleActiveFolders(codeApporteur, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération du document zip pour le Simulateur CAMPAGNE+ de suivi d\'activité
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSimulateurCampagnePlus(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSimulateurCampagnePlus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récuperation d\'une URL présignée d\'un fichier de source commissions
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSourceCommissionsFile(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSourceCommissionsFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération de la liste des fichiers sources de commissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSourcesCommissions(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSourcesCommissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération de la page de template de test interprété par Thymeleaf
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTemplate(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTemplate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération du fichier excel avec le transfers plan épargne salariale
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTransferts(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTransferts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des informations de l\'utilisateur
     * @param {string} uid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUtilisateur(uid: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUtilisateur(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Initialise un dossier de souscription avec les données d\'un apporteur d\'affaire
     * @param {InitDossier} [initDossier] Dossier avec apporteur d\&#39;affaire
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public initDossier(initDossier?: InitDossier, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).initDossier(initDossier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Webhook utilisé par Docusign pour récupérer la liasse signée
     * @param {string} tenant 
     * @param {string} uid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notifierLiasse(tenant: string, uid: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).notifierLiasse(tenant, uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enregistre en BD l\'ajout du fichier de la bibliothèque. Route appelée après qu\'un upload AWS ait réussi côté client.
     * @summary Enregistre l\'ajout d\'un fichier de la bibliothèque
     * @param {string} idDocument 
     * @param {FileMetadata} fileMetadata 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notifyLibraryDocumentFileUploaded(idDocument: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).notifyLibraryDocumentFileUploaded(idDocument, fileMetadata, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enregistre en BD l\'ajout de la page de la pièce justificative pour un dossier de souscription. Route appelée après qu\'un upload AWS ait réussi côté client.
     * @summary Enregistre l\'ajout de la page de la pièce justificative pour un dossier de souscription
     * @param {string} uid UID du dossier de souscription
     * @param {FileMetadata} fileMetadata 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notifyPageDocumentUploaded(uid: string, fileMetadata: FileMetadata, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).notifyPageDocumentUploaded(uid, fileMetadata, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Notifie le serveur après la réussite de l\'upload du document vers AWS S3.
     * @summary Enregistrement du document des Performances cumulées après son dépôt
     * @param {FileMetadata} fileMetadata 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notifyPerformancesCumuleesUploaded(fileMetadata: FileMetadata, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).notifyPerformancesCumuleesUploaded(fileMetadata, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ajout d\'un article de news
     * @param {Article} article Article
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postArticle(article: Article, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postArticle(article, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification de la gamme de fonds
     * @param {GammeFonds} gammeFonds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postGammeFonds(gammeFonds: GammeFonds, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postGammeFonds(gammeFonds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Création d\'un lien de la gamme de fonds
     * @param {LienGammeFonds} lienGammeFonds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postGammeFondsLien(lienGammeFonds: LienGammeFonds, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postGammeFondsLien(lienGammeFonds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ajout d\'un bandeau d\'informations
     * @param {string} text 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postInfoBanner(text: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postInfoBanner(text, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enregistrement des données d\'un fichier source des commissions
     * @param {SourceCommissions} sourceCommissions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postSourceCommissions(sourceCommissions: SourceCommissions, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postSourceCommissions(sourceCommissions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification d\'un article de news
     * @param {string} id 
     * @param {Article} article 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putArticle(id: string, article: Article, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putArticle(id, article, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification d\'un lien de la gamme de fonds
     * @param {LienGammeFonds} lienGammeFonds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putGammeFondsLien(lienGammeFonds: LienGammeFonds, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putGammeFondsLien(lienGammeFonds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification d\'un bandeau d\'information
     * @param {string} id 
     * @param {InfoBanner} infoBanner 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putInfoBanner(id: string, infoBanner: InfoBanner, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putInfoBanner(id, infoBanner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Réception des données au parcours intermédiaire de la simulation d\'intéressement
     * @param {File} quickRecapPdf 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quickSimulationData(quickRecapPdf: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).quickSimulationData(quickRecapPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Régénération d\'un token JWT pour le tunel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rafraichirToken(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rafraichirToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recherche une entreprise dans la base SIRENE à partir du SIRET
     * @param {string} [siret] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rechercherEntreprise(siret?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rechercherEntreprise(siret, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération de l\'URL DocuSign pour que l\'utilisateur puisse signer sa liasse de souscription
     * @param {string} uid 
     * @param {string} [redirectUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public recupererUrlSignature(uid: string, redirectUrl?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).recupererUrlSignature(uid, redirectUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Réception des données pour la sauvegarde d\'un tunnel personnalisé
     * @param {CustomTunnelData} customTunnelData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public saveTunnel(customTunnelData: CustomTunnelData, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveTunnel(customTunnelData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des informations du dossier de souscription à partir de l\'uid entreprise
     * @param {string} [uidEntreprise] id de l\&#39;entreprise du dossier
     * @param {string} [codeApporteur] le code apporteur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchDossierSouscription(uidEntreprise?: string, codeApporteur?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchDossierSouscription(uidEntreprise, codeApporteur, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Réception des données de la simulation d\'intéressement
     * @param {GeneratorData} generatorData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public simulationData(generatorData: GeneratorData, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).simulationData(generatorData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permet de transmettre le dossier PEI PERcoi finalisé
     * @param {string} uid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public transmettreDossier(uid: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).transmettreDossier(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification de l\'abondement PEE/PERCOI de l\'utilisateur
     * @param {string} uid 
     * @param {Dispositifs} dispositifs 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAbondements(uid: string, dispositifs: Dispositifs, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAbondements(uid, dispositifs, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ajout de l’Annexe KYC Amundi dans la liasse de documents pour signature électronique
     * @param {string} uid 
     * @param {DonneesKYC} donneesKYC 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAnnexeKYC(uid: string, donneesKYC: DonneesKYC, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAnnexeKYC(uid, donneesKYC, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mise à jour d\'un apporteur de part son UUID
     * @param {string} uuid UUID Apporteur
     * @param {ApporteurWithFoldersId} [apporteurWithFoldersId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateApporteur(uuid: string, apporteurWithFoldersId?: ApporteurWithFoldersId, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateApporteur(uuid, apporteurWithFoldersId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification du téléphone d\'un apporteur
     * @param {ApporteurTelephoneUpdate} [apporteurTelephoneUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateApporteurTelephone(apporteurTelephoneUpdate?: ApporteurTelephoneUpdate, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateApporteurTelephone(apporteurTelephoneUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification d\'un document de la bibliotheque
     * @param {string} idDocument 
     * @param {BibliothequeDocument} [bibliothequeDocument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBibliothequeDocument(idDocument: string, bibliothequeDocument?: BibliothequeDocument, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateBibliothequeDocument(idDocument, bibliothequeDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification d\'une section de la bibliotheque
     * @param {number} idSection 
     * @param {BibliothequeSection} bibliothequeSection 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBibliothequeSection(idSection: number, bibliothequeSection: BibliothequeSection, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateBibliothequeSection(idSection, bibliothequeSection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modifiation des colleges et taux
     * @param {string} uid 
     * @param {CategoriesSalaries} categoriesSalaries 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCategoriesSalaries(uid: string, categoriesSalaries: CategoriesSalaries, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCategoriesSalaries(uid, categoriesSalaries, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification du commentaire lié à un dossier
     * @param {Commentaire} commentaire 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCommentaireDossier(commentaire: Commentaire, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCommentaireDossier(commentaire, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Renseignement du RIB de l\'utilisateur
     * @param {string} uid 
     * @param {CompteDePrelevement} compteDePrelevement 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCompteDePrelevement(uid: string, compteDePrelevement: CompteDePrelevement, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCompteDePrelevement(uid, compteDePrelevement, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Depot de consentement d\'un salarié
     * @param {string} refInterne 
     * @param {string} idEmployee 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateConsent(refInterne: string, idEmployee: string, file: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateConsent(refInterne, idEmployee, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification des informations de l\'entreprise
     * @param {string} uid 
     * @param {Entreprise} entreprise 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEntreprise(uid: string, entreprise: Entreprise, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateEntreprise(uid, entreprise, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permet d\'ouvrir/fermer le flux HARVEST pour les distributeurs spécifiés
     * @param {boolean} toActivate ouverture/fermeture du flux
     * @param {Array<string>} [requestBody] liste des apporteurs uuids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateFluxHarvest(toActivate: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFluxHarvest(toActivate, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification de la fonction du dirigeant dans l\'entreprise
     * @param {string} uid 
     * @param {Fonction} fonction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateFonctionDansEntreprise(uid: string, fonction: Fonction, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFonctionDansEntreprise(uid, fonction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modifiation des frais de contrat dans le dossier
     * @param {string} uid 
     * @param {FraisContrat} fraisContrat 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateFraisContrat(uid: string, fraisContrat: FraisContrat, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFraisContrat(uid, fraisContrat, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modifiation choix de garantie de prevoyance au dossier
     * @param {string} uid 
     * @param {GarantiesPrevoyance} garantiesPrevoyance 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateGarantiesPrevoyance(uid: string, garantiesPrevoyance: GarantiesPrevoyance, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateGarantiesPrevoyance(uid, garantiesPrevoyance, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification des informations de l\'utilisateur
     * @param {string} uid 
     * @param {Dirigeant} dirigeant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateInformationsUtilisateur(uid: string, dirigeant: Dirigeant, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateInformationsUtilisateur(uid, dirigeant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mettre en place de l\'intérèssement ou non
     * @param {string} uid 
     * @param {Interessement} interessement 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateInteressement(uid: string, interessement: Interessement, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateInteressement(uid, interessement, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mise en place de la participation ou non en cas d\'entreprise de plus de 50 salariés
     * @param {string} uid 
     * @param {Participation} participation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateParticipation(uid: string, participation: Participation, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateParticipation(uid, participation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mise à jour des valeurs du PASS
     * @param {Pass} pass 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePass(pass: Pass, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePass(pass, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Informations à renseigner en cas de transfert d\'un PEE / PERCO
     * @param {string} uid 
     * @param {PlanExistant} planExistant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePlanExistant(uid: string, planExistant: PlanExistant, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePlanExistant(uid, planExistant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification des positions des sections de la bibliotheque
     * @param {Array<BibliothequeSection>} bibliothequeSection 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePositionSections(bibliothequeSection: Array<BibliothequeSection>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePositionSections(bibliothequeSection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mise à jour booléen activation du service
     * @param {ServiceActivation} serviceActivation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateService(serviceActivation: ServiceActivation, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateService(serviceActivation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Changement de l\'étape
     * @param {string} uid 
     * @param {EtapeDossier} [etapeDossier] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateStep(uid: string, etapeDossier?: EtapeDossier, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateStep(uid, etapeDossier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mise à jour des informations de tarification
     * @param {string} uid 
     * @param {Tarification} tarification 
     * @param {boolean} [sauvegardeSeule] Si true, sauvegarde la tarification sans changer l\&#39;étape du dossier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTarification(uid: string, tarification: Tarification, sauvegardeSeule?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateTarification(uid, tarification, sauvegardeSeule, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload des fichiers utilisé pour un tunnel personnalisé d\'un réseau
     * @param {string} reseau 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadCustomTunnelFiles(reseau: string, files?: Array<File>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadCustomTunnelFiles(reseau, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload du justificatif \'Carte professionnelle\' (profession libérale)
     * @param {string} uid 
     * @param {Array<File>} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPageCarteProfessionnelle(uid: string, files: Array<File>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadPageCarteProfessionnelle(uid, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload du justificatif \'Copie du décret de reconnaissance de l’utilité publique\' (association)
     * @param {string} uid 
     * @param {Array<File>} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPageDecretReco(uid: string, files: Array<File>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadPageDecretReco(uid, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload de la copie du pouvoir donné pour engager l\'entreprise en matière d\'épargne salariale si le nom du signataire n’apparaît pas sur l\'extrait K-Bis ou l\'extrait du registre des métiers
     * @param {string} uid 
     * @param {Array<File>} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPageDelegationPouvoir(uid: string, files: Array<File>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadPageDelegationPouvoir(uid, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload d\'un justificatif d\'identité
     * @param {string} uid 
     * @param {Array<File>} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPageJustificatifIdentite(uid: string, files: Array<File>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadPageJustificatifIdentite(uid, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload du justificatif d\'identité de l\'entreprise (KBIS ou justificatif d\'inscription à l\'ordre des métiers)
     * @param {string} uid 
     * @param {Array<File>} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPageJustificatifIdentiteEntreprise(uid: string, files: Array<File>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadPageJustificatifIdentiteEntreprise(uid, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload d\'un côté d\'un justificatif d\'identité
     * @param {string} uid 
     * @param {boolean} isRecto 
     * @param {Array<File>} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPageJustificatifIdentite_2(uid: string, isRecto: boolean, files: Array<File>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadPageJustificatifIdentite_2(uid, isRecto, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload d\'un justificatif d\'identité (passeport)
     * @param {string} uid 
     * @param {Array<File>} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPagePasseport(uid: string, files: Array<File>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadPagePasseport(uid, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload du justificatif \'Récépissé de déclaration en préfecture\' (association)
     * @param {string} uid 
     * @param {Array<File>} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPageRecepDeclaPref(uid: string, files: Array<File>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadPageRecepDeclaPref(uid, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload du justificatif \'Récépissé d’insertion légale au Journal Officiel\' (association)
     * @param {string} uid 
     * @param {Array<File>} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPageRecepInsertion(uid: string, files: Array<File>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadPageRecepInsertion(uid, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload des statuts de l\'entreprise
     * @param {string} uid 
     * @param {Array<File>} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPageStatuts(uid: string, files: Array<File>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadPageStatuts(uid, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary validation ou rejet d\'un consentement d\'un ou plusieurs salariés
     * @param {string} refInterne 
     * @param {string} idEmployee 
     * @param {boolean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validationConsent(refInterne: string, idEmployee: string, body: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).validationConsent(refInterne, idEmployee, body, options).then((request) => request(this.axios, this.basePath));
    }
}



